export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: unknown; output: unknown };
  JSON: { input: unknown; output: unknown };
};

export type AcademicUnit = {
  __typename?: "AcademicUnit";
  academicUnitType?: Maybe<AcademicUnitType>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type AcademicUnitFilterInput = {
  campus?: InputMaybe<IntFilterInput>;
  fields?: InputMaybe<AcademicUnitFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  school?: InputMaybe<IntFilterInput>;
  subject?: InputMaybe<IntFilterInput>;
};

export type AcademicUnitType = {
  __typename?: "AcademicUnitType";
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type AccessCode = {
  __typename?: "AccessCode";
  code?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isGlobal?: Maybe<Scalars["Boolean"]["output"]>;
  isSystem?: Maybe<Scalars["Boolean"]["output"]>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type Area = {
  __typename?: "Area";
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type Assignation = {
  __typename?: "Assignation";
  accesible?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  path?: Maybe<Scalars["String"]["output"]>;
  permissions?: Maybe<UserPermissionsAction>;
};

export type AssignationAccesibleArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AssignationPermissionsArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AssignationType = {
  __typename?: "AssignationType";
  code: Scalars["String"]["output"];
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  end?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isSystem?: Maybe<Scalars["Boolean"]["output"]>;
  maxAssignmentsByLink?: Maybe<Scalars["Int"]["output"]>;
  meta?: Maybe<Scalars["String"]["output"]>;
  modified?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  start?: Maybe<Scalars["String"]["output"]>;
};

export type AssignationTypeFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<AssignationTypeFilterFieldsInput>>>;
  code?: InputMaybe<StringFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  isSystem?: InputMaybe<BooleanFilterInput>;
  linkId?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<AssignationTypeFilterFieldsInput>>>;
};

export type AssignationTypeFilterInput = {
  fields?: InputMaybe<AssignationTypeFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type AssignationTypePage = {
  __typename?: "AssignationTypePage";
  items: Array<AssignationType>;
  pageInfo?: Maybe<PageInfo>;
};

export type AssignmentFilterInput = {
  hasBlocks?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasClassrooms?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasInstructors?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AttributesFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<ProcessStatFilterFieldsInput>>>;
  isProductive?: InputMaybe<BooleanFilterInput>;
  isProtected?: InputMaybe<BooleanFilterInput>;
  isReal?: InputMaybe<BooleanFilterInput>;
  isVisible?: InputMaybe<BooleanFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ProcessStatFilterFieldsInput>>>;
};

export type AvailabilityFilterInput = {
  blockRange?: InputMaybe<TimeRangeInputType>;
  dayId: Array<InputMaybe<Scalars["ID"]["input"]>>;
  intervalRange?: InputMaybe<IdRangeInput>;
  intervals?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type BaseMutation = {
  __typename?: "BaseMutation";
  changeContext?: Maybe<CubeContext>;
  createScenario?: Maybe<Scenario>;
  updatePreferences?: Maybe<PreferencesType>;
};

export type BaseMutationChangeContextArgs = {
  input?: InputMaybe<ChangeContextInput>;
};

export type BaseMutationCreateScenarioArgs = {
  input?: InputMaybe<CreateScenarioInput>;
};

export type BaseMutationUpdatePreferencesArgs = {
  input?: InputMaybe<PreferencesInput>;
};

export type BaseQuery = {
  __typename?: "BaseQuery";
  assignations?: Maybe<Array<Maybe<Assignation>>>;
  catalogs?: Maybe<Array<Maybe<Catalog>>>;
  classroomBookingTypes?: Maybe<ClassroomBookingTypePage>;
  customFields?: Maybe<Array<Maybe<Tag>>>;
  customUrls?: Maybe<Array<Maybe<CustomUrls>>>;
  forecasts?: Maybe<Array<Maybe<Forecast>>>;
  modelExtensions?: Maybe<ModelExtensionPage>;
  modules?: Maybe<Array<Maybe<Module>>>;
  onOff?: Maybe<OnOffFeatures>;
  processStats?: Maybe<ProcessStatPageType>;
  productConfigurations?: Maybe<Array<Maybe<ProductConfiguration>>>;
  reports?: Maybe<Array<Maybe<Report>>>;
  scenarioConfigurations?: Maybe<Array<Maybe<ScenarioConfiguration>>>;
  scenarios?: Maybe<Array<Maybe<Scenario>>>;
  settings?: Maybe<SettingPage>;
  tags?: Maybe<TagPage>;
  user?: Maybe<User>;
  userConfigurations?: Maybe<Array<Maybe<UserConfiguration>>>;
  users?: Maybe<UserPage>;
  workspaces?: Maybe<Array<Maybe<Workspace>>>;
};

export type BaseQueryClassroomBookingTypesArgs = {
  filter?: InputMaybe<ClassroomBookingTypeFilterInput>;
};

export type BaseQueryCustomFieldsArgs = {
  resourceType: ResourceType;
};

export type BaseQueryModelExtensionsArgs = {
  filter?: InputMaybe<ModelExtensionFilterInput>;
};

export type BaseQueryProcessStatsArgs = {
  filter?: InputMaybe<ProcessStatFilterInput>;
};

export type BaseQueryScenariosArgs = {
  filter?: InputMaybe<ScenariosInput>;
};

export type BaseQuerySettingsArgs = {
  filter?: InputMaybe<SettingFilterInput>;
};

export type BaseQueryTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
};

export type BaseQueryUserArgs = {
  id: Scalars["ID"]["input"];
};

export type BaseQueryUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
};

export type Block = {
  __typename?: "Block";
  day: Day;
  endingTime?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isSystem?: Maybe<Scalars["Boolean"]["output"]>;
  startingTime?: Maybe<Scalars["String"]["output"]>;
  usable?: Maybe<Scalars["Boolean"]["output"]>;
};

export type BlockCustom = {
  __typename?: "BlockCustom";
  end?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  start?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type BlockFilterFieldsInput = {
  and?: InputMaybe<Array<BlockFilterFieldsInput>>;
  dayId?: InputMaybe<IntFilterInput>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  isSystem?: InputMaybe<Scalars["Boolean"]["input"]>;
  or?: InputMaybe<Array<BlockFilterFieldsInput>>;
};

export type BlockFilterInput = {
  fields?: InputMaybe<BlockFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type BlockPage = {
  __typename?: "BlockPage";
  items: Array<Block>;
  pageInfo?: Maybe<PageInfo>;
};

export type BlockRange = {
  __typename?: "BlockRange";
  end?: Maybe<Block>;
  start?: Maybe<Block>;
};

export type BlockingThreshold = {
  __typename?: "BlockingThreshold";
  current_datetime?: Maybe<Scalars["String"]["output"]>;
  period?: Maybe<Scalars["String"]["output"]>;
  time?: Maybe<Scalars["String"]["output"]>;
  when?: Maybe<Scalars["String"]["output"]>;
};

export type BlocksAssignmentNotAllowed = {
  __typename?: "BlocksAssignmentNotAllowed";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type BookingClassroomClash = EditorClash & {
  __typename?: "BookingClassroomClash";
  block?: Maybe<Block>;
  classroom?: Maybe<Classroom>;
  interval?: Maybe<Interval>;
  sessions?: Maybe<Array<Maybe<Session>>>;
};

export type BooleanFilterInput = {
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  nil?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Building = {
  __typename?: "Building";
  campus: Campus;
  classrooms?: Maybe<Array<Maybe<Classroom>>>;
  code?: Maybe<Scalars["String"]["output"]>;
  custom?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type BuildingFilterFieldsInput = {
  and?: InputMaybe<BuildingFilterFieldsInput>;
  campusId?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  or?: InputMaybe<BuildingFilterFieldsInput>;
};

export type BuildingFilterInput = {
  fields?: InputMaybe<BuildingFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type BuildingPage = {
  __typename?: "BuildingPage";
  items: Array<Building>;
  pageInfo?: Maybe<PageInfo>;
};

export type Bundle = {
  __typename?: "Bundle";
  capacity?: Maybe<Scalars["Int"]["output"]>;
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  links?: Maybe<Array<Maybe<Link>>>;
  name?: Maybe<Scalars["String"]["output"]>;
  sections?: Maybe<Array<Maybe<Section>>>;
  term?: Maybe<Term>;
};

export type BundleChangesetInput = {
  changeVacancies?: InputMaybe<Array<InputMaybe<ChangeBundleVacanciesInput>>>;
};

export type BundlePage = {
  __typename?: "BundlePage";
  items: Array<Bundle>;
  pageInfo?: Maybe<PageInfo>;
};

export type BundleValidationError = InvalidLinkChanges;

export enum CalendarPerspectiveEnum {
  AllWeeksView = "ALL_WEEKS_VIEW",
  AnnualView = "ANNUAL_VIEW",
  WeeksByTermView = "WEEKS_BY_TERM_VIEW",
}

export type CalendarRange = {
  __typename?: "CalendarRange";
  endTime?: Maybe<Scalars["String"]["output"]>;
  startTime?: Maybe<Scalars["String"]["output"]>;
};

export type Campus = {
  __typename?: "Campus";
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isGlobal?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type CampusFilterInput = {
  fields?: InputMaybe<CampusSearchFieldsInput>;
  ignoreAccessFilters?: InputMaybe<Scalars["Boolean"]["input"]>;
  pagination?: InputMaybe<PaginationInput>;
};

export type CampusPage = {
  __typename?: "CampusPage";
  items: Array<Campus>;
  pageInfo?: Maybe<PageInfo>;
};

export type CampusSearchFieldsInput = {
  and?: InputMaybe<CampusSearchFieldsInput>;
  or?: InputMaybe<CampusSearchFieldsInput>;
  searchTerm?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<IntFilterInput>;
};

export type CanDeletePackages = {
  __typename?: "CanDeletePackages";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  reason?: Maybe<ValidationErrorReason>;
};

export type CanEditPackages = {
  __typename?: "CanEditPackages";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  reason?: Maybe<ValidationErrorReason>;
};

export type CapacityFilterInput = {
  allowedOverflow?: InputMaybe<Scalars["Boolean"]["input"]>;
  value?: InputMaybe<IntFilterInput>;
};

export type Catalog = {
  __typename?: "Catalog";
  accesible?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  path?: Maybe<Scalars["String"]["output"]>;
  permissions?: Maybe<UserPermissionsAction>;
};

export type CatalogAccesibleArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CatalogPermissionsArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ChangeBlocksInputType = {
  day?: InputMaybe<Day>;
  days?: InputMaybe<Array<InputMaybe<Day>>>;
  endTime?: InputMaybe<Scalars["String"]["input"]>;
  op: EditorOperation;
  startTime?: InputMaybe<Scalars["String"]["input"]>;
};

export type ChangeBundleVacanciesInput = {
  changeGroupVacancies?: InputMaybe<Array<InputMaybe<ChangeGroupVacanciesInput>>>;
  linkId: Scalars["ID"]["input"];
};

export type ChangeClassroomInputType = {
  /** deprecated due to multiple allocation, must be a list of classrooms */
  classroomId?: InputMaybe<Scalars["ID"]["input"]>;
  classroomIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  op: EditorOperation;
};

export type ChangeContextInput = {
  originId?: InputMaybe<Scalars["ID"]["input"]>;
  scenarioId?: InputMaybe<Scalars["ID"]["input"]>;
  workspaceId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ChangeCourseComponentInputType = {
  courseComponentId: Scalars["ID"]["input"];
  op: EditorOperation;
};

export type ChangeGroupVacanciesInput = {
  groupId: Scalars["ID"]["input"];
  retakerVacancies?: InputMaybe<Scalars["Int"]["input"]>;
  vacancies: Scalars["Int"]["input"];
};

export type ChangeInstructorInputType = {
  /** deprecated due to multiple allocation, must be a list of classrooms */
  instructorId?: InputMaybe<Scalars["ID"]["input"]>;
  instructorIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  op: EditorOperation;
};

export type ChangeIntervalsInputType = {
  forceFork?: InputMaybe<Scalars["Boolean"]["input"]>;
  intervalIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  op: EditorOperation;
  uniqueInterval?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ChangeLog = {
  __typename?: "ChangeLog";
  comment?: Maybe<Scalars["String"]["output"]>;
  contentType?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  current: Scalars["String"]["output"];
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  expected: Scalars["String"]["output"];
  foreignKey: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  propertyUpdated: Scalars["String"]["output"];
  source?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ChangeLogFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<ChangeLogFilterFieldsInput>>>;
  contentType?: InputMaybe<StringFilterInput>;
  foreignKey?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ChangeLogFilterFieldsInput>>>;
};

export type ChangeLogFilterInput = {
  fields?: InputMaybe<ChangeLogFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ChangeLogPage = {
  __typename?: "ChangeLogPage";
  items: Array<ChangeLog>;
  pageInfo?: Maybe<PageInfo>;
};

export type ChangeVacanciesInputType = {
  op: EditorOperation;
  vacancies?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ClashesBetweenPackages = {
  __typename?: "ClashesBetweenPackages";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  reason?: Maybe<ValidationErrorReason>;
};

export type ClashesFilterInput = {
  classroom?: InputMaybe<Scalars["Boolean"]["input"]>;
  instructor?: InputMaybe<Scalars["Boolean"]["input"]>;
  package?: InputMaybe<Scalars["Boolean"]["input"]>;
  section?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Classroom = {
  __typename?: "Classroom";
  allowedOverflow?: Maybe<Scalars["Int"]["output"]>;
  assignment?: Maybe<ClassroomAssignment>;
  building: Building;
  capacity?: Maybe<Scalars["Int"]["output"]>;
  classroomType?: Maybe<ClassroomType>;
  code?: Maybe<Scalars["String"]["output"]>;
  coveragePercentage?: Maybe<Scalars["Float"]["output"]>;
  dateAvailability?: Maybe<Array<Maybe<DateAvailability>>>;
  floor?: Maybe<Scalars["Int"]["output"]>;
  freeSlots?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  isSpecialTagValue?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  totalSlots?: Maybe<Scalars["Int"]["output"]>;
  usable?: Maybe<Scalars["Boolean"]["output"]>;
  usableInBookings?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ClassroomAssignment = {
  __typename?: "ClassroomAssignment";
  chairsOccupationPercentage?: Maybe<Scalars["Float"]["output"]>;
  usagePercentage?: Maybe<Scalars["Float"]["output"]>;
};

export type ClassroomBooking = {
  __typename?: "ClassroomBooking";
  capacity?: Maybe<Scalars["Int"]["output"]>;
  classroom?: Maybe<Classroom>;
  clientCode?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  isRecurrent?: Maybe<Scalars["Boolean"]["output"]>;
  origin?: Maybe<Origin>;
  program?: Maybe<Scalars["String"]["output"]>;
  relatedProgram?: Maybe<Program>;
  responsible?: Maybe<User>;
  sessions: Array<Session>;
  status?: Maybe<ClassroomBookingStatusEnum>;
  title?: Maybe<Scalars["String"]["output"]>;
  type: ClassroomBookingType;
};

export type ClassroomBookingChangeStatusInput = {
  bookingIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
  status?: InputMaybe<ClassroomBookingStatusEnum>;
};

export type ClassroomBookingClash = {
  __typename?: "ClassroomBookingClash";
  classroom?: Maybe<Classroom>;
  classroomBooking?: Maybe<ClassroomBooking>;
  dateAvailability?: Maybe<Scalars["String"]["output"]>;
  session?: Maybe<Session>;
};

export type ClassroomBookingClashesFilterFieldsInput = {
  classroomId?: InputMaybe<IntFilterInput>;
  dateAvailability?: InputMaybe<Array<InputMaybe<DateAvailabilityFilterInput>>>;
};

export type ClassroomBookingClashesFilterInput = {
  fields?: InputMaybe<ClassroomBookingClashesFilterFieldsInput>;
  orderBy?: InputMaybe<Array<InputMaybe<ClassroomBookingClashesOrderByInputType>>>;
  pagination?: InputMaybe<PaginationInput>;
};

export enum ClassroomBookingClashesOrderByFields {
  Classroom = "classroom",
  DateAvailability = "dateAvailability",
  Session = "session",
}

export type ClassroomBookingClashesOrderByInputType = {
  direction: OrderByDirection;
  field: ClassroomBookingClashesOrderByFields;
};

export type ClassroomBookingClashesPage = {
  __typename?: "ClassroomBookingClashesPage";
  items: Array<ClassroomBookingClash>;
  pageInfo?: Maybe<PageInfo>;
};

export type ClassroomBookingCrudChangesetInput = {
  creates?: InputMaybe<Array<InputMaybe<CreateClassroomBookingInput>>>;
  deletes?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  updates?: InputMaybe<Array<InputMaybe<UpdateClassroomBookingInput>>>;
};

export type ClassroomBookingCrudInput = {
  /** the changes we want to perform in this operation */
  changesets?: InputMaybe<ClassroomBookingCrudChangesetInput>;
  /** a rehearsal of a performance or procedure before the real one */
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** update booking details only or all data */
  onlyDetails?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** kip any validations that could cancel the operation */
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ClassroomBookingCrudPayload = {
  __typename?: "ClassroomBookingCrudPayload";
  creates?: Maybe<Array<Maybe<ClassroomBookingPayload>>>;
  deletes?: Maybe<Array<Maybe<ClassroomBookingPayload>>>;
  updates?: Maybe<Array<Maybe<ClassroomBookingPayload>>>;
};

export type ClassroomBookingCrudResult = {
  __typename?: "ClassroomBookingCrudResult";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  onlyDetails?: Maybe<Scalars["Boolean"]["output"]>;
  payload?: Maybe<ClassroomBookingCrudPayload>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  /** If user can skip some of the validations because has not assigned an ability */
  userCanSkipValidations?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ClassroomBookingFilterFieldsInput = {
  and?: InputMaybe<Array<ClassroomBookingFilterFieldsInput>>;
  classroom?: InputMaybe<ClassroomFilterFieldsInput>;
  classroomId?: InputMaybe<IntFilterInput>;
  date?: InputMaybe<StringFilterInput>;
  /** To search by a set of fields related to bookings  */
  fullText?: InputMaybe<Scalars["String"]["input"]>;
  isActive?: InputMaybe<BooleanFilterInput>;
  or?: InputMaybe<Array<ClassroomBookingFilterFieldsInput>>;
  responsible?: InputMaybe<UserFilterFieldsInput>;
  status?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ClassroomBookingFilterInput = {
  fields?: InputMaybe<ClassroomBookingFilterFieldsInput>;
  orderBy?: InputMaybe<Array<InputMaybe<ClassroomBookingOrderByInput>>>;
  pagination?: InputMaybe<PaginationInput>;
};

export enum ClassroomBookingOrderByFields {
  Building = "building",
  Classroom = "classroom",
  CreatedAt = "createdAt",
  Date = "date",
  Responsible = "responsible",
  Status = "status",
  Title = "title",
}

export type ClassroomBookingOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field: ClassroomBookingOrderByFields;
};

export type ClassroomBookingPage = {
  __typename?: "ClassroomBookingPage";
  activeCount?: Maybe<Scalars["Int"]["output"]>;
  expiredCount?: Maybe<Scalars["Int"]["output"]>;
  fields?: Maybe<Scalars["String"]["output"]>;
  items: Array<ClassroomBooking>;
  pageInfo?: Maybe<PageInfo>;
  pendingCount?: Maybe<Scalars["Int"]["output"]>;
};

export type ClassroomBookingPayload = {
  __typename?: "ClassroomBookingPayload";
  booking?: Maybe<ClassroomBooking>;
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  validationErrors?: Maybe<Array<Maybe<ClassroomBookingValidationErrorUnion>>>;
};

export enum ClassroomBookingStatusEnum {
  Cancelled = "cancelled",
  Confirmed = "confirmed",
  Expired = "expired",
  Pending = "pending",
  Rejected = "rejected",
}

export type ClassroomBookingStatusPayload = {
  __typename?: "ClassroomBookingStatusPayload";
  bookings?: Maybe<Array<Maybe<ClassroomBooking>>>;
  /**
   *
   *                             # Whatever the operation was actually commited to the database.
   *                             # Cases:
   *                             # - true: when dryRun=false and no errors
   *                             # - true: when dryRun=false and skippedValidations=true
   *                             # - false: otherwise
   *
   */
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  validationErrors?: Maybe<Array<Maybe<ClassroomBookingValidationErrorUnion>>>;
};

export type ClassroomBookingType = {
  __typename?: "ClassroomBookingType";
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ClassroomBookingTypeFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<SettingFilterFieldsInput>>>;
  code?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SettingFilterFieldsInput>>>;
};

export type ClassroomBookingTypeFilterInput = {
  fields?: InputMaybe<ClassroomBookingTypeFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ClassroomBookingTypePage = {
  __typename?: "ClassroomBookingTypePage";
  items: Array<ClassroomBookingType>;
  pageInfo?: Maybe<PageInfo>;
};

export type ClassroomBookingValidationErrorUnion =
  | ClassroomClash
  | InvalidDate
  | InvalidInput
  | InvalidSessionInHoliday;

export type ClassroomClash = EditorClash & {
  __typename?: "ClassroomClash";
  block?: Maybe<Block>;
  classroom?: Maybe<Classroom>;
  interval?: Maybe<Interval>;
  sessions?: Maybe<Array<Maybe<Session>>>;
};

export type ClassroomFilter = {
  __typename?: "ClassroomFilter";
  classrooms?: Maybe<ClassroomPage>;
  id: Scalars["ID"]["output"];
};

export type ClassroomFilterClassroomsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type ClassroomFilterFieldsInput = {
  and?: InputMaybe<Array<ClassroomFilterFieldsInput>>;
  availabilities?: InputMaybe<Array<InputMaybe<AvailabilityFilterInput>>>;
  availability?: InputMaybe<AvailabilityFilterInput>;
  building?: InputMaybe<BuildingFilterFieldsInput>;
  buildingId?: InputMaybe<IntFilterInput>;
  capacity?: InputMaybe<CapacityFilterInput>;
  classroomTypeId?: InputMaybe<IntFilterInput>;
  dateAvailability?: InputMaybe<Array<InputMaybe<DateAvailabilityFilterInput>>>;
  /** To search by a set of fields related to classrooms (classroom.name, building.code)  */
  fullText?: InputMaybe<Scalars["String"]["input"]>;
  hasEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<ClassroomFilterFieldsInput>>;
  usableInBookings?: InputMaybe<BooleanFilterInput>;
};

export type ClassroomFilterInput = {
  fields?: InputMaybe<ClassroomFilterFieldsInput>;
  orderBy?: InputMaybe<Array<InputMaybe<ClassroomOrderByInput>>>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ClassroomInfo = {
  __typename?: "ClassroomInfo";
  classroom?: Maybe<Classroom>;
};

export enum ClassroomOrderByFields {
  Building = "building",
  Capacity = "capacity",
  ClientCode = "client_code",
  CoveragePercentage = "coverage_percentage",
  Id = "id",
  Name = "name",
}

export type ClassroomOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field: ClassroomOrderByFields;
};

export type ClassroomPage = {
  __typename?: "ClassroomPage";
  items: Array<Classroom>;
  pageInfo?: Maybe<PageInfo>;
};

export type ClassroomPriority = {
  __typename?: "ClassroomPriority";
  classroomType: ClassroomType;
  id: Scalars["ID"]["output"];
};

export type ClassroomSearchInput = {
  blockIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  dayId?: InputMaybe<Scalars["Int"]["input"]>;
  endingTime?: InputMaybe<Scalars["String"]["input"]>;
  intervalIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  respectRequireCapacity?: InputMaybe<Scalars["Boolean"]["input"]>;
  respectRequiredBuildings?: InputMaybe<Scalars["Boolean"]["input"]>;
  respectRequiredClassroomType?: InputMaybe<Scalars["Boolean"]["input"]>;
  searchTerm?: InputMaybe<Scalars["String"]["input"]>;
  sectionId: Scalars["ID"]["input"];
  size?: InputMaybe<Scalars["Int"]["input"]>;
  startingTime?: InputMaybe<Scalars["String"]["input"]>;
  useNonUsableClassrooms?: InputMaybe<Scalars["Boolean"]["input"]>;
  useOverload?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ClassroomType = {
  __typename?: "ClassroomType";
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ClassroomTypeFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<ClassroomTypeFilterFieldsInput>>>;
  buildingId?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ClassroomTypeFilterFieldsInput>>>;
};

export type ClassroomTypeFilterInput = {
  fields?: InputMaybe<ClassroomTypeFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ClassroomTypePage = {
  __typename?: "ClassroomTypePage";
  items: Array<ClassroomType>;
  pageInfo?: Maybe<PageInfo>;
};

export type ClassroomsAssignmentNotAllowed = {
  __typename?: "ClassroomsAssignmentNotAllowed";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type Component = {
  __typename?: "Component";
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentFilterFieldsInput = {
  and?: InputMaybe<Array<ComponentFilterFieldsInput>>;
  code?: InputMaybe<StringFilterInput>;
  courseComponent?: InputMaybe<CourseComponentFilterFieldsInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ComponentFilterFieldsInput>>;
};

export type ComponentFilterInput = {
  fields?: InputMaybe<ComponentFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ComponentPage = {
  __typename?: "ComponentPage";
  items: Array<Component>;
  pageInfo?: Maybe<PageInfo>;
};

export type Course = {
  __typename?: "Course";
  access?: Maybe<Scalars["String"]["output"]>;
  active?: Maybe<Scalars["Boolean"]["output"]>;
  annotations?: Maybe<Scalars["String"]["output"]>;
  buildings: Array<Building>;
  canEdit?: Maybe<Scalars["Boolean"]["output"]>;
  chooseElectiveRule?: Maybe<Scalars["String"]["output"]>;
  choosePackageRule?: Maybe<Scalars["String"]["output"]>;
  code: Scalars["String"]["output"];
  corequisiteKeys?: Maybe<Array<Scalars["String"]["output"]>>;
  courseComponents?: Maybe<Array<Maybe<CourseComponent>>>;
  courseType?: Maybe<Scalars["String"]["output"]>;
  courseTypes?: Maybe<Array<Scalars["ID"]["output"]>>;
  credits?: Maybe<Scalars["Float"]["output"]>;
  crosslistDemands?: Maybe<Array<Maybe<Demand>>>;
  curriculum: Curriculum;
  customFields?: Maybe<Array<Maybe<CustomField>>>;
  demand?: Maybe<Demand>;
  edhCanEdit?: Maybe<Scalars["Boolean"]["output"]>;
  electiveCode?: Maybe<Scalars["String"]["output"]>;
  equivalences?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  generatesPackages?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  isRule?: Maybe<Scalars["Boolean"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  legacy?: Maybe<Scalars["Boolean"]["output"]>;
  level?: Maybe<Scalars["Int"]["output"]>;
  meta?: Maybe<Scalars["String"]["output"]>;
  mirrorCode?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  prerequisites?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  requireSameInstructorsAcrossFormats?: Maybe<Scalars["Boolean"]["output"]>;
  requisitesExpression?: Maybe<Scalars["String"]["output"]>;
  ruleCode?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  sectionsCount?: Maybe<Scalars["Int"]["output"]>;
  tag?: Maybe<Scalars["String"]["output"]>;
  tags?: Maybe<Scalars["String"]["output"]>;
  totalExpectedBlocks?: Maybe<Scalars["Int"]["output"]>;
  usable?: Maybe<Scalars["Boolean"]["output"]>;
  widespread?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CourseTagArgs = {
  id: Scalars["ID"]["input"];
};

export type CourseComponent = {
  __typename?: "CourseComponent";
  academicStandard?: Maybe<Scalars["Int"]["output"]>;
  attendanceType?: Maybe<Scalars["String"]["output"]>;
  classroomPriorities?: Maybe<Array<Maybe<ClassroomPriority>>>;
  component: Component;
  course: Course;
  eventsPerInterval?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  impartationIntervals?: Maybe<Array<Maybe<Interval>>>;
  inline?: Maybe<Scalars["Boolean"]["output"]>;
  legacy?: Maybe<Scalars["Boolean"]["output"]>;
  maxBlocksPerSession?: Maybe<Scalars["Int"]["output"]>;
  maxSectionSize?: Maybe<Scalars["Int"]["output"]>;
  minSectionSize?: Maybe<Scalars["Int"]["output"]>;
  modulation?: Maybe<Scalars["String"]["output"]>;
  online?: Maybe<Scalars["Boolean"]["output"]>;
  optSectionSize?: Maybe<Scalars["Int"]["output"]>;
  requiresClassroom?: Maybe<Scalars["Boolean"]["output"]>;
  requiresInstructor?: Maybe<Scalars["Boolean"]["output"]>;
  requiresTimeslot?: Maybe<Scalars["Boolean"]["output"]>;
  sessionsPerInterval?: Maybe<Scalars["Int"]["output"]>;
  stripePriorities?: Maybe<Array<Maybe<StripePriority>>>;
  type?: Maybe<Scalars["String"]["output"]>;
  usable?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CourseComponentFilterFieldsInput = {
  and?: InputMaybe<Array<CourseComponentFilterFieldsInput>>;
  componentId?: InputMaybe<IntFilterInput>;
  course?: InputMaybe<CourseFilterFieldsInput>;
  courseId?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<CourseComponentFilterFieldsInput>>;
};

export type CourseComponentFilterInput = {
  fields?: InputMaybe<CourseComponentFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type CourseComponentPage = {
  __typename?: "CourseComponentPage";
  items: Array<CourseComponent>;
  pageInfo?: Maybe<PageInfo>;
};

export type CourseFilter = {
  __typename?: "CourseFilter";
  courses?: Maybe<CoursePage>;
  id: Scalars["ID"]["output"];
};

export type CourseFilterCoursesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type CourseFilterFieldsInput = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  and?: InputMaybe<Array<CourseFilterFieldsInput>>;
  code?: InputMaybe<StringFilterInput>;
  componentId?: InputMaybe<IntFilterInput>;
  curriculum?: InputMaybe<CurriculumFilterFieldsInput>;
  curriculumId?: InputMaybe<IdFilterInput>;
  filterAccessCode?: InputMaybe<Scalars["Boolean"]["input"]>;
  generatesPackages?: InputMaybe<BooleanFilterInput>;
  hasEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<IdFilterInput>;
  level?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CourseFilterFieldsInput>>;
  program?: InputMaybe<ProgramFilterFieldsInput>;
  terms?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CourseFilterInput = {
  fields?: InputMaybe<CourseFilterFieldsInput>;
  ignoreAccessFilters?: InputMaybe<Scalars["Boolean"]["input"]>;
  pagination?: InputMaybe<PaginationInput>;
};

export type CourseInfo = {
  __typename?: "CourseInfo";
  course?: Maybe<Course>;
};

export type CoursePage = {
  __typename?: "CoursePage";
  items: Array<Course>;
  pageInfo?: Maybe<PageInfo>;
};

export type CreateClassroomBookingInput = {
  capacity?: InputMaybe<Scalars["Int"]["input"]>;
  classroomBookingTypeId: Scalars["ID"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  isRecurrent?: InputMaybe<Scalars["Boolean"]["input"]>;
  programId?: InputMaybe<Scalars["ID"]["input"]>;
  responsibleId: Scalars["ID"]["input"];
  sessionAssignmentBookings: Array<InputMaybe<SessionAssignmentBookingInput>>;
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
  title: Scalars["String"]["input"];
};

export type CreateGroupInput = {
  campusId?: InputMaybe<Scalars["ID"]["input"]>;
  capacity?: InputMaybe<Scalars["Int"]["input"]>;
  clientCode?: InputMaybe<Scalars["String"]["input"]>;
  code?: InputMaybe<Scalars["String"]["input"]>;
  courseId?: InputMaybe<Scalars["ID"]["input"]>;
  /** a rehearsal of a performance or procedure before the real one. (for @nicolás) */
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  language?: InputMaybe<Language>;
  linkId?: InputMaybe<Scalars["ID"]["input"]>;
  programId?: InputMaybe<Scalars["ID"]["input"]>;
  sharedPackComponent?: InputMaybe<Array<InputMaybe<SharedPackComponent>>>;
  /** kip any validations that could cancel the operation */
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
  termId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateLinkInput = {
  assignSections?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  code: Scalars["String"]["input"];
  courseId: Scalars["ID"]["input"];
  createGroup?: InputMaybe<CreateGroupInput>;
  createSections?: InputMaybe<Array<InputMaybe<CreateSectionInput>>>;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
  termId: Scalars["ID"]["input"];
};

export type CreateLinkPayload = {
  __typename?: "CreateLinkPayload";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  link?: Maybe<Link>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  validationErrors?: Maybe<Array<Maybe<LinkValidationErrorUnion>>>;
};

export type CreatePackageInput = {
  /** for multiedit */
  linkId?: InputMaybe<Scalars["ID"]["input"]>;
  /** for multiedit */
  packageId?: InputMaybe<Scalars["ID"]["input"]>;
  /** for multiedit */
  packageName?: InputMaybe<Scalars["String"]["input"]>;
  /** for multiedit */
  populationCode?: InputMaybe<Scalars["String"]["input"]>;
  /** for multiedit */
  populationId?: InputMaybe<Scalars["ID"]["input"]>;
  /** for multiedit */
  termId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateProgrammingStructureInput = {
  campusCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  code: Scalars["String"]["input"];
  isPublished?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  programmingStructureParts: Array<InputMaybe<CreateProgrammingStructurePartInput>>;
  subjectCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CreateProgrammingStructurePartInput = {
  blockDuration: Scalars["Int"]["input"];
  code: Scalars["String"]["input"];
  dependenciesCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  programmingStructureStageId: Scalars["ID"]["input"];
  references?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type CreateScenarioInput = {
  code?: InputMaybe<Scalars["String"]["input"]>;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  deep?: InputMaybe<Scalars["Boolean"]["input"]>;
  enviromentId: Scalars["ID"]["input"];
  fronScenarioId?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateSectionInput = {
  code?: InputMaybe<Scalars["String"]["input"]>;
  courseComponentId: Scalars["ID"]["input"];
};

export type CubeContext = {
  __typename?: "CubeContext";
  originId?: Maybe<Scalars["ID"]["output"]>;
  scenarioId?: Maybe<Scalars["ID"]["output"]>;
  workspaceId?: Maybe<Scalars["ID"]["output"]>;
};

export type CubeContextInput = {
  originId?: InputMaybe<Scalars["ID"]["input"]>;
  scenarioId?: InputMaybe<Scalars["ID"]["input"]>;
  workspaceId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CubeMutation = {
  __typename?: "CubeMutation";
  classroomBookingChangeStatus?: Maybe<ClassroomBookingStatusPayload>;
  classroomBookingsCrud?: Maybe<ClassroomBookingCrudResult>;
  createClassroomBooking?: Maybe<ClassroomBookingPayload>;
  createGroup: GroupPayload;
  createLink: CreateLinkPayload;
  createSession: EditSessionPayload;
  disableGroup: GroupPayload;
  disableSection?: Maybe<EditSectionPayload>;
  disableSessions: DisableSessionPayload;
  editBundle: EditBundlePayload;
  editGroupLabels?: Maybe<EditGroupLabelsPayload>;
  editGroupTexts?: Maybe<EditGroupTextsPayload>;
  editPackageLabels?: Maybe<EditPackageLabelsPayload>;
  editSection: EditSectionPayload;
  editSession: EditSessionPayload;
  groupEnrollmentRestrictions: GroupPayload;
  groupsManagerCrud?: Maybe<GroupsManagerCrudResult>;
  inferLinkCode: Scalars["String"]["output"];
  instructorResponsibilityUpsert?: Maybe<InstructorResponsibilityPayload>;
  linksCrud?: Maybe<LinkCrudResult>;
  migrateGroup: GroupPayload;
  packageLinkAssignment?: Maybe<PackageLinkAssignmentResult>;
  packagesCrud?: Maybe<PackageCrudResult>;
  programmingStructuresCrud?: Maybe<ProgrammingStructureCrudResult>;
  sessionMultiEdit?: Maybe<SessionsMultiEditPayload>;
  sessionsByHoliday?: Maybe<SessionsByHolidaysPayload>;
  sessionsCrud?: Maybe<SessionCrudResult>;
  updateAssignationType: InstructorResponsibilityPayload;
  updateGroupIsActive: GroupPayload;
  updateGroupIsReferent: GroupPayload;
  updateGroupVisible: GroupPayload;
  updateInstructorLinkTags: UpdateInstructorLinkTagsPayload;
};

export type CubeMutationClassroomBookingChangeStatusArgs = {
  input?: InputMaybe<ClassroomBookingChangeStatusInput>;
};

export type CubeMutationClassroomBookingsCrudArgs = {
  input: ClassroomBookingCrudInput;
};

export type CubeMutationCreateClassroomBookingArgs = {
  input?: InputMaybe<CreateClassroomBookingInput>;
};

export type CubeMutationCreateGroupArgs = {
  input: CreateGroupInput;
};

export type CubeMutationCreateLinkArgs = {
  input?: InputMaybe<CreateLinkInput>;
};

export type CubeMutationCreateSessionArgs = {
  input?: InputMaybe<EditSessionInput>;
};

export type CubeMutationDisableGroupArgs = {
  groupId: Scalars["ID"]["input"];
};

export type CubeMutationDisableSectionArgs = {
  input?: InputMaybe<EditSectionInput>;
};

export type CubeMutationDisableSessionsArgs = {
  intervalIds: Array<InputMaybe<Scalars["ID"]["input"]>>;
  sessionIds: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type CubeMutationEditBundleArgs = {
  input?: InputMaybe<EditBundleInput>;
};

export type CubeMutationEditGroupLabelsArgs = {
  input?: InputMaybe<EditGroupLabelsInput>;
};

export type CubeMutationEditGroupTextsArgs = {
  input?: InputMaybe<EditGroupTextsInput>;
};

export type CubeMutationEditPackageLabelsArgs = {
  input?: InputMaybe<EditPackageLabelsInput>;
};

export type CubeMutationEditSectionArgs = {
  input?: InputMaybe<EditSectionInput>;
};

export type CubeMutationEditSessionArgs = {
  input?: InputMaybe<EditSessionInput>;
};

export type CubeMutationGroupEnrollmentRestrictionsArgs = {
  input: GroupEnrollmentRestrictionsInput;
};

export type CubeMutationGroupsManagerCrudArgs = {
  input: GroupsManagerCrudInput;
};

export type CubeMutationInferLinkCodeArgs = {
  courseId: Scalars["ID"]["input"];
  index: Scalars["Int"]["input"];
};

export type CubeMutationInstructorResponsibilityUpsertArgs = {
  input?: InputMaybe<InstructorResponsibilityInput>;
};

export type CubeMutationLinksCrudArgs = {
  input: LinkCrudInput;
};

export type CubeMutationMigrateGroupArgs = {
  input: GroupMigrationInput;
};

export type CubeMutationPackageLinkAssignmentArgs = {
  input: PackageLinkAssignmentInput;
};

export type CubeMutationPackagesCrudArgs = {
  input: PackageCrudInput;
};

export type CubeMutationProgrammingStructuresCrudArgs = {
  input: ProgrammingStructureCrudInput;
};

export type CubeMutationSessionMultiEditArgs = {
  input: SessionsMultiEditInput;
};

export type CubeMutationSessionsByHolidayArgs = {
  input?: InputMaybe<DeleteSessionsByHolidaysInput>;
};

export type CubeMutationSessionsCrudArgs = {
  input: SessionCrudInput;
};

export type CubeMutationUpdateAssignationTypeArgs = {
  input: UpdateAssignationTypeInput;
};

export type CubeMutationUpdateGroupIsActiveArgs = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  groupId: Scalars["ID"]["input"];
  isActive: Scalars["Boolean"]["input"];
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CubeMutationUpdateGroupIsReferentArgs = {
  groupId: Scalars["ID"]["input"];
  isReferent: Scalars["Boolean"]["input"];
};

export type CubeMutationUpdateGroupVisibleArgs = {
  groupId: Scalars["ID"]["input"];
  visible: Scalars["Boolean"]["input"];
};

export type CubeMutationUpdateInstructorLinkTagsArgs = {
  input: UpdateInstructorLinkTagsInput;
};

export type CubeQuery = {
  __typename?: "CubeQuery";
  bundle?: Maybe<Bundle>;
  bundles: BundlePage;
  classroomBooking?: Maybe<ClassroomBooking>;
  classroomBookingClashes: ClassroomBookingClashesPage;
  classroomBookings?: Maybe<ClassroomBookingPage>;
  classrooms: ClassroomPage;
  classroomsAvailabilities: ClassroomPage;
  complementedPopulations: PopulationPage;
  coursesWithSections: CoursePage;
  demands?: Maybe<DemandPage>;
  editorClassroom: ClassroomPage;
  editorInstructors: InstructorPage;
  editorResources?: Maybe<Array<Maybe<EditorResouceView>>>;
  editorRestrictions?: Maybe<Array<Maybe<EditorRestriction>>>;
  editorView?: Maybe<EditorView>;
  editorWeeks?: Maybe<Array<Maybe<Interval>>>;
  event?: Maybe<Event>;
  events: EventPage;
  forecastCourses?: Maybe<CoursePage>;
  forecastCurriculums?: Maybe<CurriculumPage>;
  group?: Maybe<Group>;
  groupEnrollments: GroupEnrollmentPage;
  groups: GroupPage;
  groupsManagerGroupChanges: GroupChangePage;
  groupsManagerSearch: GroupPage;
  instructors: InstructorPage;
  instructorsAdvancedSearch?: Maybe<InstructorPage>;
  link?: Maybe<Link>;
  links: LinkPage;
  microprogrammingPreview?: Maybe<MicroprogrammingPreviewResult>;
  package?: Maybe<Package>;
  packages: PackagePage;
  packagesLegacy: PackagePage;
  population?: Maybe<Population>;
  populations: PopulationPage;
  programmingStructure?: Maybe<ProgrammingStructure>;
  programmingStructures?: Maybe<ProgrammingStructurePage>;
  scheduleInstances?: Maybe<Array<Maybe<ScheduleInstance>>>;
  section?: Maybe<Section>;
  sections: SectionPage;
  sectionsSearch: SectionPage;
  session?: Maybe<Session>;
  sessionRecommendations?: Maybe<SessionRecommendation>;
  sessions: SessionPage;
};

export type CubeQueryBundleArgs = {
  id: Scalars["ID"]["input"];
};

export type CubeQueryBundlesArgs = {
  filter?: InputMaybe<PaginationInput>;
};

export type CubeQueryClassroomBookingArgs = {
  id: Scalars["ID"]["input"];
};

export type CubeQueryClassroomBookingClashesArgs = {
  filter?: InputMaybe<ClassroomBookingClashesFilterInput>;
};

export type CubeQueryClassroomBookingsArgs = {
  filter?: InputMaybe<ClassroomBookingFilterInput>;
};

export type CubeQueryClassroomsArgs = {
  filter?: InputMaybe<PaginationInput>;
};

export type CubeQueryClassroomsAvailabilitiesArgs = {
  classroomBookingId?: InputMaybe<Scalars["ID"]["input"]>;
  filter?: InputMaybe<ClassroomFilterInput>;
};

export type CubeQueryComplementedPopulationsArgs = {
  filter?: InputMaybe<PopulationFilterInput>;
  termId: Scalars["ID"]["input"];
};

export type CubeQueryCoursesWithSectionsArgs = {
  filter?: InputMaybe<PaginationInput>;
};

export type CubeQueryDemandsArgs = {
  filter?: InputMaybe<DemandFilterInput>;
};

export type CubeQueryEditorClassroomArgs = {
  filter?: InputMaybe<ClassroomSearchInput>;
};

export type CubeQueryEditorInstructorsArgs = {
  filter?: InputMaybe<InstructorSearchInput>;
};

export type CubeQueryEditorResourcesArgs = {
  resourceId?: InputMaybe<Scalars["ID"]["input"]>;
  resourceType?: InputMaybe<ResourceType>;
};

export type CubeQueryEditorRestrictionsArgs = {
  resourceId?: InputMaybe<Scalars["ID"]["input"]>;
  resourceType?: InputMaybe<ResourceType>;
};

export type CubeQueryEditorViewArgs = {
  resourceId?: InputMaybe<Scalars["ID"]["input"]>;
  resourceType?: InputMaybe<ResourceType>;
};

export type CubeQueryEditorWeeksArgs = {
  resourceId?: InputMaybe<Scalars["ID"]["input"]>;
  resourceType?: InputMaybe<ResourceType>;
};

export type CubeQueryEventArgs = {
  id: Scalars["ID"]["input"];
};

export type CubeQueryEventsArgs = {
  filter?: InputMaybe<PaginationInput>;
};

export type CubeQueryForecastCoursesArgs = {
  filter?: InputMaybe<CourseFilterInput>;
};

export type CubeQueryForecastCurriculumsArgs = {
  filter?: InputMaybe<CurriculumFilterInput>;
};

export type CubeQueryGroupArgs = {
  id: Scalars["ID"]["input"];
};

export type CubeQueryGroupEnrollmentsArgs = {
  filter?: InputMaybe<GroupsManagerEnrollmentsFilterInputType>;
  groupId?: InputMaybe<Scalars["ID"]["input"]>;
  linkId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CubeQueryGroupsArgs = {
  filter?: InputMaybe<PaginationInput>;
};

export type CubeQueryGroupsManagerGroupChangesArgs = {
  filter?: InputMaybe<GroupsManagerGroupChangesFilterInput>;
};

export type CubeQueryGroupsManagerSearchArgs = {
  filter?: InputMaybe<GroupsManagerSearchFilterInput>;
};

export type CubeQueryInstructorsArgs = {
  filter?: InputMaybe<PaginationInput>;
};

export type CubeQueryInstructorsAdvancedSearchArgs = {
  filter?: InputMaybe<InstructorFilterInput>;
};

export type CubeQueryLinkArgs = {
  id: Scalars["ID"]["input"];
};

export type CubeQueryLinksArgs = {
  filter?: InputMaybe<LinkFilterInput>;
};

export type CubeQueryMicroprogrammingPreviewArgs = {
  input: MicroprogrammingPreviewInput;
};

export type CubeQueryPackageArgs = {
  id: Scalars["ID"]["input"];
};

export type CubeQueryPackagesArgs = {
  campusId?: InputMaybe<Scalars["ID"]["input"]>;
  filter?: InputMaybe<PackageFilterInput>;
};

export type CubeQueryPackagesLegacyArgs = {
  campusId?: InputMaybe<Scalars["ID"]["input"]>;
  filter?: InputMaybe<PaginationInput>;
};

export type CubeQueryPopulationArgs = {
  id: Scalars["ID"]["input"];
};

export type CubeQueryPopulationsArgs = {
  filter?: InputMaybe<PaginationInput>;
};

export type CubeQueryProgrammingStructureArgs = {
  id: Scalars["ID"]["input"];
};

export type CubeQueryProgrammingStructuresArgs = {
  filter?: InputMaybe<ProgrammingStructureFilterInput>;
};

export type CubeQueryScheduleInstancesArgs = {
  filter: ScheduleInstanceFilterInput;
};

export type CubeQuerySectionArgs = {
  id: Scalars["ID"]["input"];
};

export type CubeQuerySectionsArgs = {
  filter?: InputMaybe<PaginationInput>;
};

export type CubeQuerySectionsSearchArgs = {
  filter?: InputMaybe<SectionFilterInput>;
};

export type CubeQuerySessionArgs = {
  id: Scalars["ID"]["input"];
};

export type CubeQuerySessionRecommendationsArgs = {
  sessionId?: InputMaybe<Scalars["ID"]["input"]>;
  sessionIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type CubeQuerySessionsArgs = {
  filter?: InputMaybe<PaginationInput>;
};

export type Curriculum = {
  __typename?: "Curriculum";
  access?: Maybe<Scalars["String"]["output"]>;
  code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  maxCreditsPerTerm?: Maybe<Scalars["Int"]["output"]>;
  maxCreditsPerYear?: Maybe<Scalars["Int"]["output"]>;
  maxSubjectsPerTerm?: Maybe<Scalars["Int"]["output"]>;
  maxSubjectsPerYear?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
  program: Program;
};

export type CurriculumFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<CurriculumFilterFieldsInput>>>;
  code?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<InputMaybe<CurriculumFilterFieldsInput>>>;
  program?: InputMaybe<ProgramFilterFieldsInput>;
  program_id?: InputMaybe<IntFilterInput>;
};

export type CurriculumFilterInput = {
  fields?: InputMaybe<CurriculumFilterFieldsInput>;
  groupByCode?: InputMaybe<Scalars["Boolean"]["input"]>;
  ignoreAccessFilters?: InputMaybe<Scalars["Boolean"]["input"]>;
  pagination?: InputMaybe<PaginationInput>;
};

export type CurriculumPage = {
  __typename?: "CurriculumPage";
  items: Array<Curriculum>;
  pageInfo?: Maybe<PageInfo>;
};

export type CustomField = {
  __typename?: "CustomField";
  code?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type CustomModel = {
  __typename?: "CustomModel";
  code: Scalars["String"]["output"];
  dataType: Scalars["String"]["output"];
  enabled: Scalars["Boolean"]["output"];
  end?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isVisible?: Maybe<Scalars["Boolean"]["output"]>;
  meta?: Maybe<Scalars["String"]["output"]>;
  modified?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  start: Scalars["String"]["output"];
};

export type CustomModelFilterFieldsInput = {
  and?: InputMaybe<Array<CustomModelFilterFieldsInput>>;
  code?: InputMaybe<StringFilterInput>;
  dataType?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isVisible?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CustomModelFilterFieldsInput>>;
};

export type CustomModelFilterInput = {
  fields?: InputMaybe<CustomModelFilterFieldsInput>;
  orderBy?: InputMaybe<CustomModelOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchBy?: InputMaybe<CustomModelSearchTextToSearchByInputType>;
};

export enum CustomModelOrderByFields {
  Code = "code",
  DataType = "data_type",
  Id = "id",
  Name = "name",
}

export type CustomModelOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field: CustomModelOrderByFields;
};

export type CustomModelPage = {
  __typename?: "CustomModelPage";
  items: Array<CustomModel>;
  pageInfo?: Maybe<PageInfo>;
};

export enum CustomModelSearchSearchableFieldsEnum {
  Code = "code",
  DataType = "data_type",
  Id = "id",
  Name = "name",
}

export type CustomModelSearchTextToSearchByInputType = {
  fields?: InputMaybe<Array<InputMaybe<CustomModelSearchSearchableFieldsEnum>>>;
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type CustomModelValue = {
  __typename?: "CustomModelValue";
  code: Scalars["String"]["output"];
  customModel: CustomModel;
  enabled: Scalars["Boolean"]["output"];
  end?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  meta?: Maybe<Scalars["String"]["output"]>;
  modified?: Maybe<Scalars["String"]["output"]>;
  start: Scalars["String"]["output"];
  usable?: Maybe<Scalars["Boolean"]["output"]>;
  value: Scalars["String"]["output"];
};

export type CustomModelValueFilterFieldsInput = {
  and?: InputMaybe<Array<CustomModelValueFilterFieldsInput>>;
  code?: InputMaybe<StringFilterInput>;
  customModel?: InputMaybe<CustomModelFilterFieldsInput>;
  customModelId?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<CustomModelValueFilterFieldsInput>>;
  usable?: InputMaybe<BooleanFilterInput>;
  value?: InputMaybe<StringFilterInput>;
};

export type CustomModelValueFilterInput = {
  fields?: InputMaybe<CustomModelValueFilterFieldsInput>;
  orderBy?: InputMaybe<CustomModelValueOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchBy?: InputMaybe<CustomModelValueSearchTextToSearchByInput>;
  ignoreAccessFilters?: Scalars["Boolean"]["input"];
};

export enum CustomModelValueOrderByFields {
  Code = "code",
  CustomModelId = "custom_model_id",
  Id = "id",
  Label = "label",
  Value = "value",
}

export type CustomModelValueOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field: CustomModelValueOrderByFields;
};

export type CustomModelValuePage = {
  __typename?: "CustomModelValuePage";
  items: Array<CustomModelValue>;
  pageInfo?: Maybe<PageInfo>;
};

export enum CustomModelValueSearchSearchableFieldsEnum {
  Code = "code",
  CustomModelId = "custom_model_id",
  Id = "id",
  Label = "label",
  Value = "value",
}

export type CustomModelValueSearchTextToSearchByInput = {
  fields?: InputMaybe<Array<InputMaybe<CustomModelValueSearchSearchableFieldsEnum>>>;
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type CustomUrls = {
  __typename?: "CustomUrls";
  code: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type CustomValidation = {
  __typename?: "CustomValidation";
  code?: Maybe<Scalars["String"]["output"]>;
  info?: Maybe<EditorInfoUnion>;
  items?: Maybe<Array<Maybe<CustomValidationItem>>>;
};

export type CustomValidationItem = {
  __typename?: "CustomValidationItem";
  key?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type DataQuery = {
  __typename?: "DataQuery";
  allBlocks: Array<Maybe<Block>>;
  assignationTypes: AssignationTypePage;
  blockingThreshold?: Maybe<BlockingThreshold>;
  blocks: BlockPage;
  buildings: BuildingPage;
  buildingsByCampus?: Maybe<Array<Maybe<Building>>>;
  calendarPerspectives?: Maybe<Array<Maybe<CalendarPerspectiveEnum>>>;
  campuses?: Maybe<CampusPage>;
  changeLogs?: Maybe<ChangeLogPage>;
  classroom?: Maybe<Classroom>;
  classroomTypes?: Maybe<ClassroomTypePage>;
  components?: Maybe<ComponentPage>;
  courseComponents?: Maybe<CourseComponentPage>;
  courseSearch: CoursePage;
  courses: CoursePage;
  curriculums?: Maybe<CurriculumPage>;
  customBlocks?: Maybe<BlockCustom>;
  customModelValues?: Maybe<CustomModelValuePage>;
  customModels?: Maybe<CustomModelPage>;
  departments: DepartmentPage;
  externalReferences?: Maybe<ExternalReference>;
  groupsManagerCampuses?: Maybe<CampusPage>;
  groupsManagerCourseTypes?: Maybe<GroupsManagerCourseTypePage>;
  groupsManagerDepartments?: Maybe<GroupsManagerDepartmentPage>;
  groupsManagerSchools?: Maybe<GroupsManagerSchoolPage>;
  groupsManagerSubjects?: Maybe<SubjectPage>;
  holidays?: Maybe<Array<Maybe<Holiday>>>;
  institutionCalendarRange: CalendarRange;
  instructorContractTypes?: Maybe<InstructorContractTypePage>;
  intervals?: Maybe<IntervalPage>;
  labelCategories: LabelCategoryPage;
  labels: LabelPage;
  levels?: Maybe<Array<Maybe<Level>>>;
  linkLogEntry?: Maybe<LinkLogEntryPage>;
  modalities?: Maybe<ModalityPage>;
  origin?: Maybe<Origin>;
  origins?: Maybe<Array<Maybe<Origin>>>;
  programmingStructureStages: ProgrammingStructureStagePage;
  programs: ProgramPage;
  referenceCategories: ReferenceCategoryPage;
  references: ReferencePage;
  sharedPackComponents?: Maybe<Array<Maybe<SharedPackComponents>>>;
  shifts?: Maybe<ShiftPage>;
  subjects?: Maybe<SubjectPage>;
  termParts: TermPartPage;
  terms?: Maybe<TermPage>;
};

export type DataQueryAssignationTypesArgs = {
  filter?: InputMaybe<AssignationTypeFilterInput>;
};

export type DataQueryBlocksArgs = {
  filter?: InputMaybe<BlockFilterInput>;
};

export type DataQueryBuildingsArgs = {
  filter?: InputMaybe<BuildingFilterInput>;
};

export type DataQueryBuildingsByCampusArgs = {
  campusId: Scalars["ID"]["input"];
};

export type DataQueryCampusesArgs = {
  filter?: InputMaybe<CampusFilterInput>;
};

export type DataQueryChangeLogsArgs = {
  filter?: InputMaybe<ChangeLogFilterInput>;
};

export type DataQueryClassroomArgs = {
  id: Scalars["ID"]["input"];
};

export type DataQueryClassroomTypesArgs = {
  filter?: InputMaybe<ClassroomTypeFilterInput>;
};

export type DataQueryComponentsArgs = {
  filter?: InputMaybe<ComponentFilterInput>;
};

export type DataQueryCourseComponentsArgs = {
  filter?: InputMaybe<CourseComponentFilterInput>;
};

export type DataQueryCourseSearchArgs = {
  filter?: InputMaybe<CourseFilterInput>;
};

export type DataQueryCoursesArgs = {
  filter?: InputMaybe<CourseFilterInput>;
};

export type DataQueryCurriculumsArgs = {
  filter?: InputMaybe<CurriculumFilterInput>;
};

export type DataQueryCustomModelValuesArgs = {
  filter?: InputMaybe<CustomModelValueFilterInput>;
};

export type DataQueryCustomModelsArgs = {
  filter?: InputMaybe<CustomModelFilterInput>;
};

export type DataQueryDepartmentsArgs = {
  filter?: InputMaybe<DepartmentFilterInput>;
};

export type DataQueryExternalReferencesArgs = {
  crn: Scalars["String"]["input"];
  term: Scalars["String"]["input"];
};

export type DataQueryGroupsManagerCampusesArgs = {
  filter?: InputMaybe<CampusFilterInput>;
};

export type DataQueryGroupsManagerCourseTypesArgs = {
  filter?: InputMaybe<AcademicUnitFilterInput>;
};

export type DataQueryGroupsManagerDepartmentsArgs = {
  filter?: InputMaybe<AcademicUnitFilterInput>;
};

export type DataQueryGroupsManagerSchoolsArgs = {
  filter?: InputMaybe<AcademicUnitFilterInput>;
};

export type DataQueryGroupsManagerSubjectsArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
};

export type DataQueryInstructorContractTypesArgs = {
  filter?: InputMaybe<InstructorContractTypeFilterInput>;
};

export type DataQueryIntervalsArgs = {
  filter?: InputMaybe<IntervalFilterInput>;
};

export type DataQueryLabelCategoriesArgs = {
  filter?: InputMaybe<LabelCategoryFilterInput>;
};

export type DataQueryLabelsArgs = {
  filter?: InputMaybe<LabelFilterInput>;
};

export type DataQueryLinkLogEntryArgs = {
  filter?: InputMaybe<LinkLogEntryFilterInput>;
};

export type DataQueryModalitiesArgs = {
  filter?: InputMaybe<ModalityFilterInput>;
};

export type DataQueryOriginArgs = {
  id: Scalars["ID"]["input"];
};

export type DataQueryOriginsArgs = {
  filter?: InputMaybe<OriginInput>;
};

export type DataQueryProgrammingStructureStagesArgs = {
  filter?: InputMaybe<ProgrammingStructureStageFilterInput>;
};

export type DataQueryProgramsArgs = {
  filter?: InputMaybe<ProgramFilterInput>;
};

export type DataQueryReferenceCategoriesArgs = {
  filter?: InputMaybe<ReferenceCategoryFilterInput>;
};

export type DataQueryReferencesArgs = {
  filter?: InputMaybe<ReferenceFilterInput>;
};

export type DataQuerySharedPackComponentsArgs = {
  input?: InputMaybe<SharedPackComponentsInput>;
};

export type DataQueryShiftsArgs = {
  filter?: InputMaybe<ShiftFilterInput>;
};

export type DataQuerySubjectsArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
};

export type DataQueryTermPartsArgs = {
  filter?: InputMaybe<TermPartFilterInput>;
};

export type DataQueryTermsArgs = {
  filter?: InputMaybe<TermFilterInput>;
};

export type DateAvailability = {
  __typename?: "DateAvailability";
  blocks?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  date: Scalars["String"]["output"];
  endTime?: Maybe<Scalars["String"]["output"]>;
  intervalId?: Maybe<Scalars["Int"]["output"]>;
  isAvailable: Scalars["Boolean"]["output"];
  startTime?: Maybe<Scalars["String"]["output"]>;
};

export type DateAvailabilityFilterInput = {
  end: Scalars["String"]["input"];
  start: Scalars["String"]["input"];
};

export type DateTimeRangeFilterInput = {
  end?: InputMaybe<StringFilterInput>;
  start?: InputMaybe<StringFilterInput>;
};

export type DateTimeRangeInput = {
  end?: InputMaybe<Scalars["String"]["input"]>;
  start?: InputMaybe<Scalars["String"]["input"]>;
};

export enum Day {
  Friday = "FRIDAY",
  Monday = "MONDAY",
  Saturday = "SATURDAY",
  Sunday = "SUNDAY",
  Thursday = "THURSDAY",
  Tuesday = "TUESDAY",
  Wednesday = "WEDNESDAY",
}

export type DayLegacy = {
  __typename?: "DayLegacy";
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type DayTimeRange = {
  __typename?: "DayTimeRange";
  day?: Maybe<Day>;
  range?: Maybe<TimeRange>;
};

export type DeletePackageInput = {
  /** for multiedit */
  linkId?: InputMaybe<Scalars["ID"]["input"]>;
  /** for multiedit */
  packageId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type DeleteSessionsByHolidaysInput = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  minOccurrencesToDelete?: InputMaybe<Scalars["Int"]["input"]>;
  removeSessionsWithoutSchedules?: InputMaybe<Scalars["Boolean"]["input"]>;
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Demand = {
  __typename?: "Demand";
  course: Course;
  crosslist?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  origin: Origin;
  vacancies?: Maybe<Scalars["Int"]["output"]>;
};

export type DemandFilterInput = {
  pagination?: InputMaybe<PaginationInput>;
};

export type DemandPage = {
  __typename?: "DemandPage";
  items: Array<Demand>;
  pageInfo?: Maybe<PageInfo>;
};

export type Department = {
  __typename?: "Department";
  area?: Maybe<Area>;
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type DepartmentFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<DepartmentFilterFieldsInput>>>;
  code?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<DepartmentFilterFieldsInput>>>;
};

export type DepartmentFilterInput = {
  fields?: InputMaybe<DepartmentFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type DepartmentPage = {
  __typename?: "DepartmentPage";
  items: Array<Department>;
  pageInfo?: Maybe<PageInfo>;
};

export type DisableSessionPayload = {
  __typename?: "DisableSessionPayload";
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /**
   *
   *                             # Whatever the operation was actually commited to the database.
   *                             # Cases:
   *                             # - true: when dryRun=false and no errors
   *                             # - true: when dryRun=false and skippedValidations=true
   *                             # - false: otherwise
   *
   */
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  customValidations?: Maybe<Array<Maybe<CustomValidation>>>;
  intervalValidationErrors?: Maybe<Array<Maybe<IntervalValidationErrors>>>;
  session?: Maybe<Session>;
  /** This mirrors the input field `skipValidations` */
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  /** If user can skip some of the validations because has not assigned an ability */
  userCanSkipValidations?: Maybe<Scalars["Boolean"]["output"]>;
  /** List of validation errors found while executing the operation */
  validationErrors?: Maybe<Array<Maybe<EditorValidationError>>>;
};

export type EditBundleInput = {
  /** used for session creation */
  bundleId?: InputMaybe<Scalars["ID"]["input"]>;
  /** the changes we want to perform in this operation */
  changeset?: InputMaybe<BundleChangesetInput>;
  /** a rehearsal of a performance or procedure before the real one. (for @nicolás) */
  dryRun: Scalars["Boolean"]["input"];
  /** kip any validations that could cancel the operation */
  skipValidations: Scalars["Boolean"]["input"];
};

export type EditBundlePayload = {
  __typename?: "EditBundlePayload";
  bundle?: Maybe<Bundle>;
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  validationErrors?: Maybe<Array<Maybe<BundleValidationError>>>;
};

export type EditGroupInput = {
  capacity?: InputMaybe<Scalars["Int"]["input"]>;
  groupId: Scalars["Int"]["input"];
  visibility?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EditGroupLabelsInput = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  groupId: Scalars["ID"]["input"];
  labelIds: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type EditGroupLabelsPayload = {
  __typename?: "EditGroupLabelsPayload";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  group?: Maybe<Group>;
};

export type EditGroupTextsInput = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  groupId: Scalars["ID"]["input"];
  references?: InputMaybe<Array<InputMaybe<GroupReferenceInput>>>;
};

export type EditGroupTextsPayload = {
  __typename?: "EditGroupTextsPayload";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  group?: Maybe<Group>;
};

export type EditPackageInput = {
  packageId: Scalars["Int"]["input"];
  published?: InputMaybe<Scalars["Boolean"]["input"]>;
  replicated?: InputMaybe<Scalars["Boolean"]["input"]>;
  visibility?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EditPackageLabelsInput = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  labelIds: Array<InputMaybe<Scalars["ID"]["input"]>>;
  packageId: Scalars["ID"]["input"];
};

export type EditPackageLabelsPayload = {
  __typename?: "EditPackageLabelsPayload";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  package?: Maybe<Package>;
};

export type EditSectionInput = {
  /** the changes we want to perform in this operation */
  changeset?: InputMaybe<SectionChangesetInput>;
  /** a rehearsal of a performance or procedure before the real one. (for @nicolás) */
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  sectionId?: InputMaybe<Scalars["ID"]["input"]>;
  /** kip any validations that could cancel the operation */
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EditSectionPayload = {
  __typename?: "EditSectionPayload";
  /**
   *
   *                             # Whatever the operation was actually commited to the database.
   *                             # Cases:
   *                             # - true: when dryRun=false and no errors
   *                             # - true: when dryRun=false and skippedValidations=true
   *                             # - false: otherwise
   *
   */
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  section?: Maybe<Section>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  validationErrors?: Maybe<Array<Maybe<SectionValidationErrorUnion>>>;
};

export type EditSessionInput = {
  /** the changes we want to perform in this operation */
  changeset?: InputMaybe<EditorChangesetInput>;
  /** the changes we want to perform in this operation */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** a rehearsal of a performance or procedure before the real one. (for @nicolás) */
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** used for session creation */
  sectionId?: InputMaybe<Scalars["ID"]["input"]>;
  /** the session ID, used for session updates */
  sessionId?: InputMaybe<Scalars["ID"]["input"]>;
  /** kip any validations that could cancel the operation */
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EditSessionPayload = {
  __typename?: "EditSessionPayload";
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /**
   *
   *                             # Whatever the operation was actually commited to the database.
   *                             # Cases:
   *                             # - true: when dryRun=false and no errors
   *                             # - true: when dryRun=false and skippedValidations=true
   *                             # - false: otherwise
   *
   */
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  customValidations?: Maybe<Array<Maybe<CustomValidation>>>;
  intervalValidationErrors?: Maybe<Array<Maybe<IntervalValidationErrors>>>;
  session?: Maybe<Session>;
  /** This mirrors the input field `skipValidations` */
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  /** If user can skip some of the validations because has not assigned an ability */
  userCanSkipValidations?: Maybe<Scalars["Boolean"]["output"]>;
  /** List of validation errors found while executing the operation */
  validationErrors?: Maybe<Array<Maybe<EditorValidationError>>>;
};

/** Controls whether a sessionCrud operation performs regular session assignment (assignation) or creates new sections for microprogramming (programming). */
export enum EditionMode {
  /** Default. Sessions are assigned to existing sections via sectionId. */
  Assignation = "assignation",
  /** Microprogramming mode. Sessions without a sectionId will trigger the creation of a new section identified by componentId + courseId. */
  Programming = "programming",
}

export type EditorChangesetInput = {
  changeBlocks?: InputMaybe<ChangeBlocksInputType>;
  changeClassroom?: InputMaybe<ChangeClassroomInputType>;
  changeInstructor?: InputMaybe<ChangeInstructorInputType>;
  changeIntervals?: InputMaybe<ChangeIntervalsInputType>;
  changeVacancies?: InputMaybe<ChangeVacanciesInputType>;
  /** Component ID (categorias.id) for new section creation. Required when sectionId is null and creating via microprogramming */
  componentId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Course ID (cursos.id) for new section creation. Required when sectionId is null and creating via microprogramming */
  courseId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Indicates that doesnt have block assigment but needs to create an specified number of events, if is set changeBlocks is ignored */
  noScheduleEventsCount?: InputMaybe<Scalars["Int"]["input"]>;
  /** for creation */
  sectionId?: InputMaybe<Scalars["ID"]["input"]>;
  /** for multiedit */
  sessionId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Number of vacancies for the new section (default: 0) */
  vacancies?: InputMaybe<Scalars["Int"]["input"]>;
};

export type EditorClash = {
  block?: Maybe<Block>;
  interval?: Maybe<Interval>;
  sessions?: Maybe<Array<Maybe<Session>>>;
};

export type EditorInfoUnion =
  | ClassroomInfo
  | CourseInfo
  | GroupInfo
  | InstructorInfo
  | LinkInfo
  | PackageInfo
  | PopulationInfo
  | SectionInfo;

export enum EditorOperation {
  Change = "CHANGE",
  Keep = "KEEP",
  Remove = "REMOVE",
}

export type EditorResouceView = {
  __typename?: "EditorResouceView";
  sections?: Maybe<Array<Maybe<Section>>>;
};

export type EditorRestriction = {
  __typename?: "EditorRestriction";
  scheduleEvent?: Maybe<Array<Maybe<ScheduleRestrictionEvent>>>;
  type?: Maybe<RestrictionType>;
};

export type EditorValidationError =
  | BlocksAssignmentNotAllowed
  | BookingClassroomClash
  | CanDeletePackages
  | CanEditPackages
  | ClashesBetweenPackages
  | ClassroomClash
  | ClassroomsAssignmentNotAllowed
  | ExternalGroupValidation
  | GenericInvalidValidation
  | GroupsManagerValidation
  | InstructorAssignmentNotAllowed
  | InstructorAssignmentRequired
  | InstructorClash
  | InstructorExceededWeeklyBlocks
  | IntervalsAssignmentNotAllowed
  | InvalidBlock
  | InvalidBlockForInstructor
  | InvalidBuildingForCourse
  | InvalidClassroomsCapacityAssignment
  | InvalidComponentSize
  | InvalidExpectedBlocksByLink
  | InvalidFieldValidation
  | InvalidGroupCodeValidation
  | InvalidInstructorContractedBlocks
  | InvalidInstructorTravel
  | InvalidInterval
  | InvalidLabelLink
  | InvalidLinkChanges
  | InvalidLinksCourse
  | InvalidLinksPackage
  | InvalidPackageTravel
  | InvalidPastSessionEdition
  | InvalidScheduledBlocksAssignment
  | InvalidSectionChanges
  | InvalidSessionInHoliday
  | InvalidSessionInHolidayDeletion
  | InvalidTotalExpectedBlocksByLink
  | InvalidateSectionDeletion
  | LinkClash
  | PackageClash
  | PackageNotPublished
  | PackagePublishingDisabled
  | SectionClash
  | StudentClash;

export type EditorView = {
  __typename?: "EditorView";
  bookings?: Maybe<Array<Maybe<ClassroomBooking>>>;
  info?: Maybe<EditorInfoUnion>;
  sections?: Maybe<Array<Maybe<Section>>>;
};

export type EnrollmentRestriction = {
  __typename?: "EnrollmentRestriction";
  attribute: Scalars["String"]["output"];
  operator: EnrollmentRestrictionOperator;
  table: Scalars["String"]["output"];
  valueIds?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  values?: Maybe<Array<Maybe<EnrollmentRestrictionValueUnion>>>;
};

export type EnrollmentRestrictionInput = {
  /** Attribute or field for the restriction */
  attribute: Scalars["String"]["input"];
  /** Operator for the restriction */
  operator: EnrollmentRestrictionOperator;
  /** Database table for the restriction */
  table: Scalars["String"]["input"];
  /** List of values for the restriction */
  values?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** Operadores disponibles para las restricciones de inscripción */
export enum EnrollmentRestrictionOperator {
  /** Contains (contains) */
  Contains = "contains",
  /** Equal to (=) */
  Eq = "eq",
  /** Greater than (>) */
  Gt = "gt",
  /** Greater than or equal to (>=) */
  Gte = "gte",
  /** In (in) */
  In = "in",
  /** Is (is) */
  Is = "is",
  /** Less than (<) */
  Lt = "lt",
  /** Less than or equal to (<=) */
  Lte = "lte",
  /** Not equal to (!=) */
  Ne = "ne",
  /** Is null (is null) */
  Nil = "nil",
  /** Not in (not in) */
  Nin = "nin",
  /** Not contains (not contains) */
  NotContains = "not_contains",
}

export type EnrollmentRestrictionValueUnion =
  | Campus
  | Curriculum
  | CustomModelValue
  | Modality
  | Program;

export type Event = {
  __typename?: "Event";
  block?: Maybe<Block>;
  courseComponent?: Maybe<CourseComponent>;
  id: Scalars["ID"]["output"];
  interval: Interval;
  origin: Origin;
  session: Session;
  vacancies?: Maybe<Scalars["Int"]["output"]>;
};

export type EventPage = {
  __typename?: "EventPage";
  items: Array<Event>;
  pageInfo?: Maybe<PageInfo>;
};

export type ExternalGroupValidation = {
  __typename?: "ExternalGroupValidation";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  reason?: Maybe<ValidationErrorReason>;
  rejected_groups?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalReference = {
  __typename?: "ExternalReference";
  campus?: Maybe<ExternalReferenceCampus>;
  capacity?: Maybe<Scalars["Int"]["output"]>;
  enrollmentCount?: Maybe<Scalars["Int"]["output"]>;
  groupNumber?: Maybe<Scalars["String"]["output"]>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  referenceKey?: Maybe<Scalars["String"]["output"]>;
  subject?: Maybe<ExternalReferenceSubject>;
  term?: Maybe<ExternalReferenceTerm>;
};

export type ExternalReferenceCampus = {
  __typename?: "ExternalReferenceCampus";
  code?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalReferenceSubject = {
  __typename?: "ExternalReferenceSubject";
  code?: Maybe<Scalars["String"]["output"]>;
  courseNumber?: Maybe<Scalars["String"]["output"]>;
  key?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  nameEnglish?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type ExternalReferenceTerm = {
  __typename?: "ExternalReferenceTerm";
  code?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  endDate?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["String"]["output"]>;
};

export type FilterMutation = {
  __typename?: "FilterMutation";
  createClassroomFilter?: Maybe<ClassroomFilter>;
  createCourseFilter?: Maybe<CourseFilter>;
  createGroupFilter?: Maybe<GroupFilter>;
  createInstructorFilter?: Maybe<InstructorFilter>;
  createLinkFilter?: Maybe<LinkFilter>;
  createPackageFilter?: Maybe<PackageFilter>;
  createPopulationFilter?: Maybe<PopulationFilter>;
  createSectionFilter?: Maybe<SectionFilter>;
};

export type FilterMutationCreateClassroomFilterArgs = {
  filter?: InputMaybe<ClassroomFilterInput>;
};

export type FilterMutationCreateCourseFilterArgs = {
  filter?: InputMaybe<CourseFilterInput>;
};

export type FilterMutationCreateGroupFilterArgs = {
  filter?: InputMaybe<GroupFilterInput>;
};

export type FilterMutationCreateInstructorFilterArgs = {
  filter?: InputMaybe<InstructorFilterInput>;
};

export type FilterMutationCreateLinkFilterArgs = {
  filter?: InputMaybe<LinkFilterInput>;
};

export type FilterMutationCreatePackageFilterArgs = {
  filter?: InputMaybe<PackageFilterInput>;
};

export type FilterMutationCreatePopulationFilterArgs = {
  filter?: InputMaybe<PopulationFilterInput>;
};

export type FilterMutationCreateSectionFilterArgs = {
  filter?: InputMaybe<SectionFilterInput>;
};

export type FilterQuery = {
  __typename?: "FilterQuery";
  classrooms?: Maybe<ClassroomPage>;
  courses?: Maybe<CoursePage>;
  groups?: Maybe<GroupPage>;
  instructors?: Maybe<InstructorPage>;
  links?: Maybe<LinkPage>;
  packages?: Maybe<PackagePage>;
  populations?: Maybe<PopulationPage>;
  sections?: Maybe<SectionPage>;
};

export type FilterQueryClassroomsArgs = {
  filterId?: InputMaybe<Scalars["ID"]["input"]>;
  pagination?: InputMaybe<PaginationInput>;
};

export type FilterQueryCoursesArgs = {
  filterId?: InputMaybe<Scalars["ID"]["input"]>;
  pagination?: InputMaybe<PaginationInput>;
};

export type FilterQueryGroupsArgs = {
  filterId?: InputMaybe<Scalars["ID"]["input"]>;
  pagination?: InputMaybe<PaginationInput>;
};

export type FilterQueryInstructorsArgs = {
  filterId?: InputMaybe<Scalars["ID"]["input"]>;
  pagination?: InputMaybe<PaginationInput>;
};

export type FilterQueryLinksArgs = {
  filterId?: InputMaybe<Scalars["ID"]["input"]>;
  pagination?: InputMaybe<PaginationInput>;
};

export type FilterQueryPackagesArgs = {
  filterId?: InputMaybe<Scalars["ID"]["input"]>;
  pagination?: InputMaybe<PaginationInput>;
};

export type FilterQueryPopulationsArgs = {
  filterId?: InputMaybe<Scalars["ID"]["input"]>;
  pagination?: InputMaybe<PaginationInput>;
};

export type FilterQuerySectionsArgs = {
  filterId?: InputMaybe<Scalars["ID"]["input"]>;
  pagination?: InputMaybe<PaginationInput>;
};

export type Forecast = {
  __typename?: "Forecast";
  accesible?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  path?: Maybe<Scalars["String"]["output"]>;
  permissions?: Maybe<UserPermissionsAction>;
};

export type ForecastAccesibleArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ForecastPermissionsArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type GenericInvalidValidation = {
  __typename?: "GenericInvalidValidation";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  reason?: Maybe<ValidationErrorReason>;
};

export type Group = {
  __typename?: "Group";
  blocks?: Maybe<Array<Maybe<Block>>>;
  campus?: Maybe<Campus>;
  capacity?: Maybe<Scalars["Int"]["output"]>;
  clientCode?: Maybe<Scalars["String"]["output"]>;
  code?: Maybe<Scalars["String"]["output"]>;
  course?: Maybe<Course>;
  curriculum?: Maybe<Curriculum>;
  customFields?: Maybe<Array<Maybe<CustomField>>>;
  enrollmentStats?: Maybe<GroupEnrollmentStats>;
  enrollmentsCount?: Maybe<Scalars["Int"]["output"]>;
  externalStats?: Maybe<GroupExternalStats>;
  groupCapacity?: Maybe<GroupCapacity>;
  groupCapacityChangeDetails?: Maybe<Array<Maybe<GroupCapacityChangeDetails>>>;
  groupEnrollmentRestrictions?: Maybe<Array<Maybe<EnrollmentRestriction>>>;
  groupSections?: Maybe<Array<Maybe<GroupSection>>>;
  id: Scalars["ID"]["output"];
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  isEditable?: Maybe<GroupIsEditable>;
  isReferent?: Maybe<Scalars["Boolean"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  labels?: Maybe<Array<Maybe<Label>>>;
  links?: Maybe<Array<Maybe<Link>>>;
  name?: Maybe<Scalars["String"]["output"]>;
  primaryInstructor?: Maybe<Instructor>;
  references?: Maybe<Array<Maybe<Reference>>>;
  referentType?: Maybe<Scalars["String"]["output"]>;
  scheduleSummary?: Maybe<Array<Maybe<GroupScheduleSummary>>>;
  subject?: Maybe<Subject>;
  term?: Maybe<Term>;
  text?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  totalBlocks?: Maybe<Scalars["Int"]["output"]>;
  totalBlocksWithInstructors?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  utilization?: Maybe<Scalars["Float"]["output"]>;
  visibleForEnrollment?: Maybe<Scalars["Boolean"]["output"]>;
};

export type GroupCapacity = {
  __typename?: "GroupCapacity";
  calculatedCapacity?: Maybe<Scalars["Int"]["output"]>;
  calculatedCapacityReason?: Maybe<Scalars["String"]["output"]>;
  calculatedConfigMaxCapacity?: Maybe<Scalars["Int"]["output"]>;
  calculatedConfigMinCapacity?: Maybe<Scalars["Int"]["output"]>;
  configMaxCapacity?: Maybe<Scalars["Int"]["output"]>;
  configMinCapacity?: Maybe<Scalars["Int"]["output"]>;
  defaultCapacityPercentage?: Maybe<Scalars["Float"]["output"]>;
  effectiveMaxCapacity?: Maybe<Scalars["Int"]["output"]>;
  effectiveMinCapacity?: Maybe<Scalars["Int"]["output"]>;
  group?: Maybe<Group>;
  id: Scalars["ID"]["output"];
  retakerCapacity?: Maybe<Scalars["Int"]["output"]>;
};

export type GroupCapacityChangeDetails = {
  __typename?: "GroupCapacityChangeDetails";
  currentCapacity?: Maybe<Scalars["Int"]["output"]>;
  expectedCapacity?: Maybe<Scalars["Int"]["output"]>;
  group?: Maybe<Group>;
  groupCapacityChangeRequest?: Maybe<GroupCapacityChangeRequest>;
  id?: Maybe<Scalars["ID"]["output"]>;
  originId?: Maybe<Scalars["ID"]["output"]>;
};

export type GroupCapacityChangeRequest = {
  __typename?: "GroupCapacityChangeRequest";
  changeCode?: Maybe<Scalars["String"]["output"]>;
  created?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  meta?: Maybe<Scalars["String"]["output"]>;
  modified?: Maybe<Scalars["DateTime"]["output"]>;
  requestCode?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<User>;
};

export type GroupChange = {
  __typename?: "GroupChange";
  comment?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["String"]["output"]>;
  current: Scalars["String"]["output"];
  expected: Scalars["String"]["output"];
  group?: Maybe<Group>;
  id: Scalars["String"]["output"];
  propertyUpdated: Scalars["String"]["output"];
  source?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["String"]["output"]>;
  username?: Maybe<Scalars["String"]["output"]>;
};

export type GroupChangePage = {
  __typename?: "GroupChangePage";
  items: Array<GroupChange>;
  pageInfo?: Maybe<PageInfo>;
};

export type GroupEnrollment = {
  __typename?: "GroupEnrollment";
  campus?: Maybe<Campus>;
  enrollmentDate?: Maybe<Scalars["String"]["output"]>;
  group?: Maybe<Group>;
  isWaitingList?: Maybe<Scalars["Boolean"]["output"]>;
  program?: Maybe<Program>;
  student?: Maybe<Student>;
  term?: Maybe<Term>;
};

export type GroupEnrollmentPage = {
  __typename?: "GroupEnrollmentPage";
  items: Array<GroupEnrollment>;
  pageInfo?: Maybe<PageInfo>;
};

export type GroupEnrollmentRestrictionsInput = {
  /** If true, only validates without applying changes */
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** ID of the group to modify */
  groupId: Scalars["ID"]["input"];
  /** List of restrictions to apply */
  restrictions?: InputMaybe<Array<InputMaybe<EnrollmentRestrictionInput>>>;
  /** If true, skips the validations */
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GroupEnrollmentStats = {
  __typename?: "GroupEnrollmentStats";
  bookingsCount?: Maybe<Scalars["Int"]["output"]>;
  capacity?: Maybe<Scalars["Int"]["output"]>;
  enrollmentsCount?: Maybe<Scalars["Int"]["output"]>;
  group?: Maybe<Group>;
  id: Scalars["ID"]["output"];
  instentsCount?: Maybe<Scalars["Int"]["output"]>;
  maxCapacity?: Maybe<Scalars["Int"]["output"]>;
  minCapacity?: Maybe<Scalars["Int"]["output"]>;
  optCapacity?: Maybe<Scalars["Int"]["output"]>;
  reservedCapacity?: Maybe<Scalars["Int"]["output"]>;
  retakerEnrollmentsCount?: Maybe<Scalars["Int"]["output"]>;
  usedCapacity?: Maybe<Scalars["Int"]["output"]>;
  viewsCount?: Maybe<Scalars["Int"]["output"]>;
  waitingListsCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GroupExternalStats = {
  __typename?: "GroupExternalStats";
  bookingCount?: Maybe<Scalars["Int"]["output"]>;
  capacity?: Maybe<Scalars["Int"]["output"]>;
  enrollmentCount?: Maybe<Scalars["Int"]["output"]>;
  updatedAt?: Maybe<Scalars["String"]["output"]>;
  usedCapacity?: Maybe<Scalars["Int"]["output"]>;
  waitingListCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GroupFilter = {
  __typename?: "GroupFilter";
  groups?: Maybe<GroupPage>;
  id: Scalars["ID"]["output"];
};

export type GroupFilterGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type GroupFilterFieldsInput = {
  and?: InputMaybe<Array<GroupFilterFieldsInput>>;
  campusId?: InputMaybe<IntFilterInput>;
  clientCode?: InputMaybe<StringFilterInput>;
  course?: InputMaybe<CourseFilterFieldsInput>;
  courseId?: InputMaybe<IntFilterInput>;
  curriculum?: InputMaybe<CurriculumFilterFieldsInput>;
  curriculumId?: InputMaybe<IntFilterInput>;
  departmentId?: InputMaybe<IntFilterInput>;
  label?: InputMaybe<LabelFilterFieldsInput>;
  level?: InputMaybe<IntFilterInput>;
  modalityId?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<GroupFilterFieldsInput>>;
  programId?: InputMaybe<IntFilterInput>;
  shiftId?: InputMaybe<IntFilterInput>;
};

export type GroupFilterInput = {
  fields?: InputMaybe<GroupFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type GroupInfo = {
  __typename?: "GroupInfo";
  group?: Maybe<Group>;
};

export type GroupIsEditable = {
  __typename?: "GroupIsEditable";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  reason?: Maybe<ValidationErrorReason>;
};

export type GroupMigrationInput = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Group to migrate to another link */
  groupId: Scalars["ID"]["input"];
  /** Link destination to migrate the group */
  linkId: Scalars["ID"]["input"];
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GroupPage = {
  __typename?: "GroupPage";
  items: Array<Group>;
  pageInfo?: Maybe<PageInfo>;
};

export type GroupPayload = {
  __typename?: "GroupPayload";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  group?: Maybe<Group>;
  link?: Maybe<Link>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  validationErrors?: Maybe<Array<Maybe<GroupValidationErrorUnion>>>;
};

/** Input for group references by category: one category with a list of values. */
export type GroupReferenceInput = {
  /** Reference category code (e.g. Hermes, Hermeslab, base). */
  categoryCode: Scalars["String"]["input"];
  /** List of values for this category. Hermes/Hermeslab allow only one; base allows multiple. */
  values: Array<Scalars["String"]["input"]>;
};

export type GroupScheduleSummary = {
  __typename?: "GroupScheduleSummary";
  classrooms?: Maybe<Array<Maybe<Classroom>>>;
  dateRange?: Maybe<Scalars["String"]["output"]>;
  days?: Maybe<Array<Maybe<DayLegacy>>>;
  instructors?: Maybe<Array<Maybe<Instructor>>>;
  schedule?: Maybe<Scalars["String"]["output"]>;
};

export type GroupSection = {
  __typename?: "GroupSection";
  code?: Maybe<Scalars["String"]["output"]>;
  group?: Maybe<Group>;
  id: Scalars["ID"]["output"];
  meta?: Maybe<Scalars["String"]["output"]>;
  section?: Maybe<Section>;
};

export type GroupValidationErrorUnion =
  | ExternalGroupValidation
  | GenericInvalidValidation
  | InvalidFieldValidation
  | InvalidGroupCodeValidation
  | InvalidGroupEnrollment
  | InvalidLinkChanges;

export type GroupsManagerCourseTypePage = {
  __typename?: "GroupsManagerCourseTypePage";
  items: Array<AcademicUnit>;
  pageInfo?: Maybe<PageInfo>;
};

export type GroupsManagerCrudChangesetInput = {
  creates?: InputMaybe<Array<InputMaybe<CreateGroupInput>>>;
  deletes?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  updates?: InputMaybe<Array<InputMaybe<EditGroupInput>>>;
};

export type GroupsManagerCrudInput = {
  /** the changes we want to perform in this operation */
  changesets?: InputMaybe<GroupsManagerCrudChangesetInput>;
  /** a rehearsal of a performance or procedure before the real one */
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** kip any validations that could cancel the operation */
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GroupsManagerCrudPayload = {
  __typename?: "GroupsManagerCrudPayload";
  creates?: Maybe<Array<Maybe<GroupsManagerPayload>>>;
  updates?: Maybe<Array<Maybe<GroupsManagerPayload>>>;
};

export type GroupsManagerCrudResult = {
  __typename?: "GroupsManagerCrudResult";
  payload?: Maybe<GroupsManagerCrudPayload>;
  /** If user can skip some of the validations because has not assigned an ability */
  userCanSkipValidations?: Maybe<Scalars["Boolean"]["output"]>;
};

export type GroupsManagerDepartmentPage = {
  __typename?: "GroupsManagerDepartmentPage";
  items: Array<AcademicUnit>;
  pageInfo?: Maybe<PageInfo>;
};

export type GroupsManagerEnrollmentsFilterInputType = {
  orderBy?: InputMaybe<GroupsManagerEnrollmentsOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchBy?: InputMaybe<GroupsManagerEnrollmentsTextToSearchByInputType>;
};

export enum GroupsManagerEnrollmentsOrderByFieldsEnum {
  Campus = "campus",
  Date = "date",
  Group = "group",
  Program = "program",
  State = "state",
  Student = "student",
}

export type GroupsManagerEnrollmentsOrderByInput = {
  direction: OrderByDirection;
  field: GroupsManagerEnrollmentsOrderByFieldsEnum;
};

export enum GroupsManagerEnrollmentsSearchableFieldsEnum {
  Campus = "campus",
  Date = "date",
  Group = "group",
  Program = "program",
  State = "state",
  Student = "student",
}

export type GroupsManagerEnrollmentsTextToSearchByInputType = {
  fields?: InputMaybe<Array<InputMaybe<GroupsManagerEnrollmentsSearchableFieldsEnum>>>;
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type GroupsManagerGroupChangesFilterFieldsInput = {
  campusId?: InputMaybe<IntFilterInput>;
  clientCode?: InputMaybe<StringFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  courseTypes?: InputMaybe<Array<InputMaybe<IntFilterInput>>>;
  dateRange?: InputMaybe<DateTimeRangeInput>;
  departmentId?: InputMaybe<IntFilterInput>;
  groupId?: InputMaybe<IntFilterInput>;
  hasEnrollments?: InputMaybe<BooleanFilterInput>;
  hasVacancies?: InputMaybe<BooleanFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  isGrouped?: InputMaybe<BooleanFilterInput>;
  isOwner?: InputMaybe<BooleanFilterInput>;
  linkId?: InputMaybe<IntFilterInput>;
  schoolId?: InputMaybe<IntFilterInput>;
  subjectId?: InputMaybe<IntFilterInput>;
  visibleForEnrollment?: InputMaybe<BooleanFilterInput>;
};

export type GroupsManagerGroupChangesFilterInput = {
  fields?: InputMaybe<GroupsManagerGroupChangesFilterFieldsInput>;
  orderBy?: InputMaybe<GroupsManagerGroupChangesOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchBy?: InputMaybe<GroupsManagerGroupChangesTextToSearchByInputType>;
};

export enum GroupsManagerGroupChangesOrderByFieldsEnum {
  Campus = "campus",
  ChangeType = "changeType",
  CourseName = "courseName",
  Date = "date",
  Detail = "detail",
  GroupCode = "groupCode",
  Responsible = "responsible",
  Status = "status",
}

export type GroupsManagerGroupChangesOrderByInput = {
  direction: OrderByDirection;
  field: GroupsManagerGroupChangesOrderByFieldsEnum;
};

export enum GroupsManagerGroupChangesSearchableFieldsEnum {
  Campus = "campus",
  ChangeType = "changeType",
  CourseName = "courseName",
  Date = "date",
  GroupCode = "groupCode",
  Responsible = "responsible",
  Status = "status",
}

export type GroupsManagerGroupChangesTextToSearchByInputType = {
  fields?: InputMaybe<Array<InputMaybe<GroupsManagerGroupChangesSearchableFieldsEnum>>>;
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type GroupsManagerPayload = {
  __typename?: "GroupsManagerPayload";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  group?: Maybe<Group>;
  validationErrors?: Maybe<Array<Maybe<EditorValidationError>>>;
};

export type GroupsManagerSchoolPage = {
  __typename?: "GroupsManagerSchoolPage";
  items: Array<AcademicUnit>;
  pageInfo?: Maybe<PageInfo>;
};

export type GroupsManagerSearchFilterFieldsInput = {
  campusId?: InputMaybe<IntFilterInput>;
  clientCode?: InputMaybe<StringFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  courseTypeIds?: InputMaybe<Array<InputMaybe<IntFilterInput>>>;
  departmentId?: InputMaybe<IntFilterInput>;
  hasEnrollments?: InputMaybe<BooleanFilterInput>;
  hasVacancies?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  isGrouped?: InputMaybe<BooleanFilterInput>;
  isOwner?: InputMaybe<BooleanFilterInput>;
  linkId?: InputMaybe<IntFilterInput>;
  packageId?: InputMaybe<IntFilterInput>;
  schoolId?: InputMaybe<IntFilterInput>;
  subjectId?: InputMaybe<IntFilterInput>;
  sumCapacities?: InputMaybe<BooleanFilterInput>;
  visibleForEnrollment?: InputMaybe<BooleanFilterInput>;
};

export type GroupsManagerSearchFilterInput = {
  fields?: InputMaybe<GroupsManagerSearchFilterFieldsInput>;
  orderBy?: InputMaybe<GroupsManagerSearchOrderByInputType>;
  pagination?: InputMaybe<PaginationInput>;
  searchBy?: InputMaybe<GroupsManagerSearchTextToSearchByInputType>;
};

export enum GroupsManagerSearchOrderByFields {
  CalculatedCapacity = "calculatedCapacity",
  Campus = "campus",
  Capacity = "capacity",
  CourseName = "courseName",
  GroupCode = "groupCode",
  GroupOrCampus = "groupOrCampus",
  GroupType = "groupType",
  MainInstructor = "mainInstructor",
  MinMax = "minMax",
  State = "state",
  Subterm = "subterm",
}

export type GroupsManagerSearchOrderByInputType = {
  direction: OrderByDirection;
  field: GroupsManagerSearchOrderByFields;
};

export enum GroupsManagerSearchSearchableFieldsEnum {
  Campus = "campus",
  Capacity = "capacity",
  CourseName = "courseName",
  GroupCode = "groupCode",
  GroupOrCampus = "groupOrCampus",
  GroupType = "groupType",
  MainInstructor = "mainInstructor",
  Subterm = "subterm",
}

export type GroupsManagerSearchTextToSearchByInputType = {
  fields?: InputMaybe<Array<InputMaybe<GroupsManagerSearchSearchableFieldsEnum>>>;
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type GroupsManagerValidation = {
  __typename?: "GroupsManagerValidation";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  reason?: Maybe<ValidationErrorReason>;
};

export type Holiday = {
  __typename?: "Holiday";
  code: Scalars["String"]["output"];
  date?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type IdFilterInput = {
  eq?: InputMaybe<Scalars["ID"]["input"]>;
  in?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type IdRangeInput = {
  end: Scalars["ID"]["input"];
  start: Scalars["ID"]["input"];
};

export type Institution = {
  __typename?: "Institution";
  code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  users?: Maybe<Array<Maybe<Role>>>;
  workspace?: Maybe<Array<Maybe<Workspace>>>;
};

export type Instructor = {
  __typename?: "Instructor";
  assignment?: Maybe<InstructorAssignment>;
  blocks?: Maybe<Array<Maybe<Block>>>;
  code?: Maybe<Scalars["String"]["output"]>;
  contract: Scalars["String"]["output"];
  contractType?: Maybe<InstructorContractType>;
  customFields?: Maybe<Array<Maybe<CustomField>>>;
  hasAccess?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  link?: Maybe<InstructorLink>;
  /** @deprecated renamed. Use link field */
  linkResponsibility?: Maybe<InstructorLink>;
  maxBlocks?: Maybe<Scalars["Int"]["output"]>;
  maxCourseComponents?: Maybe<Scalars["Int"]["output"]>;
  maxSections?: Maybe<Scalars["Int"]["output"]>;
  minBlocks?: Maybe<Scalars["Int"]["output"]>;
  minCourses?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  priority?: Maybe<Scalars["Int"]["output"]>;
  teachings?: Maybe<Array<Maybe<Teaching>>>;
  usable?: Maybe<Scalars["Boolean"]["output"]>;
};

export type InstructorLinkArgs = {
  linkId: Scalars["ID"]["input"];
};

export type InstructorLinkResponsibilityArgs = {
  linkId: Scalars["ID"]["input"];
};

export type InstructorAssignment = {
  __typename?: "InstructorAssignment";
  averagePerIntervalBlocks?: Maybe<Scalars["Float"]["output"]>;
  blocks?: Maybe<Scalars["Int"]["output"]>;
  currentYearBlocks?: Maybe<Scalars["Int"]["output"]>;
  nextYearBlocks?: Maybe<Scalars["Int"]["output"]>;
  totalAssignedBlocks?: Maybe<Scalars["Int"]["output"]>;
  totalAssignedBlocksWithBTR?: Maybe<Scalars["Int"]["output"]>;
  totalRemainingBlocks?: Maybe<Scalars["Int"]["output"]>;
  totalRemainingBlocksCurrentYear?: Maybe<Scalars["Int"]["output"]>;
  totalRemainingBlocksNextYear?: Maybe<Scalars["Int"]["output"]>;
  usagePercentage?: Maybe<Scalars["Float"]["output"]>;
};

export type InstructorAssignmentNotAllowed = {
  __typename?: "InstructorAssignmentNotAllowed";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type InstructorAssignmentRequired = {
  __typename?: "InstructorAssignmentRequired";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type InstructorClash = EditorClash & {
  __typename?: "InstructorClash";
  block?: Maybe<Block>;
  instructor?: Maybe<Instructor>;
  interval?: Maybe<Interval>;
  sessions?: Maybe<Array<Maybe<Session>>>;
};

export type InstructorContractType = {
  __typename?: "InstructorContractType";
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type InstructorContractTypeFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<ShiftFilterFieldsInput>>>;
  code?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ShiftFilterFieldsInput>>>;
};

export type InstructorContractTypeFilterInput = {
  fields?: InputMaybe<InstructorContractTypeFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type InstructorContractTypePage = {
  __typename?: "InstructorContractTypePage";
  items: Array<InstructorContractType>;
  pageInfo?: Maybe<PageInfo>;
};

export type InstructorExceededWeeklyBlocks = {
  __typename?: "InstructorExceededWeeklyBlocks";
  assignableBlocks?: Maybe<Scalars["Int"]["output"]>;
  exceededBlocks?: Maybe<Scalars["Int"]["output"]>;
  instructor?: Maybe<Instructor>;
};

export type InstructorFilter = {
  __typename?: "InstructorFilter";
  id: Scalars["ID"]["output"];
  instructors?: Maybe<InstructorPage>;
};

export type InstructorFilterInstructorsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type InstructorFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<InstructorFilterFieldsInput>>>;
  assignedBlocks?: InputMaybe<IntFilterInput>;
  availabilities?: InputMaybe<Array<InputMaybe<AvailabilityFilterInput>>>;
  availability?: InputMaybe<AvailabilityFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  contractTypeId?: InputMaybe<IntFilterInput>;
  courseId?: InputMaybe<IntFilterInput>;
  courseLevel?: InputMaybe<IntFilterInput>;
  dummy?: InputMaybe<BooleanFilterInput>;
  filterAccessCode?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<InstructorFilterFieldsInput>>>;
  program?: InputMaybe<ProgramFilterFieldsInput>;
};

export type InstructorFilterInput = {
  fields?: InputMaybe<InstructorFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type InstructorInfo = {
  __typename?: "InstructorInfo";
  assignedBlocks?: Maybe<Scalars["Int"]["output"]>;
  assignedCourses?: Maybe<Scalars["Int"]["output"]>;
  assignedSections?: Maybe<Scalars["Int"]["output"]>;
  instructor?: Maybe<Instructor>;
};

export type InstructorLink = {
  __typename?: "InstructorLink";
  assignationType?: Maybe<AssignationType>;
  blocksPercentage: Scalars["Int"]["output"];
  components?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  id: Scalars["ID"]["output"];
  instructor: Instructor;
  isPrimary?: Maybe<Scalars["Boolean"]["output"]>;
  link: Link;
  paymentPercentage?: Maybe<Scalars["Float"]["output"]>;
  tags?: Maybe<Scalars["JSON"]["output"]>;
  teachingHoursPercentage?: Maybe<Scalars["Float"]["output"]>;
  totalBlocks: Scalars["Int"]["output"];
};

export type InstructorLinkValidationErrorUnion = InvalidInput;

export type InstructorPage = {
  __typename?: "InstructorPage";
  items: Array<Instructor>;
  pageInfo?: Maybe<PageInfo>;
};

export type InstructorResponsibilityChangesetInput = {
  instructorId: Scalars["ID"]["input"];
  isPrimary?: InputMaybe<Scalars["Boolean"]["input"]>;
  linkId: Scalars["ID"]["input"];
  paymentPercentage?: InputMaybe<Scalars["Float"]["input"]>;
  teachingHoursPercentage?: InputMaybe<Scalars["Float"]["input"]>;
  value?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InstructorResponsibilityInput = {
  changeset: Array<InputMaybe<InstructorResponsibilityChangesetInput>>;
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InstructorResponsibilityPayload = {
  __typename?: "InstructorResponsibilityPayload";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  validations?: Maybe<Array<Maybe<InstructorLinkValidationErrorUnion>>>;
};

export type InstructorSearchInput = {
  blockIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  dayId?: InputMaybe<Scalars["Int"]["input"]>;
  endingTime?: InputMaybe<Scalars["String"]["input"]>;
  intervalIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  respectInstructorAvailability?: InputMaybe<Scalars["Boolean"]["input"]>;
  respectInstructorHours?: InputMaybe<Scalars["Boolean"]["input"]>;
  respectRequiredInstructor?: InputMaybe<Scalars["Boolean"]["input"]>;
  searchTerm?: InputMaybe<Scalars["String"]["input"]>;
  sectionId: Scalars["ID"]["input"];
  size?: InputMaybe<Scalars["Int"]["input"]>;
  startingTime?: InputMaybe<Scalars["String"]["input"]>;
};

export type IntFilterInput = {
  eq?: InputMaybe<Scalars["Int"]["input"]>;
  gt?: InputMaybe<Scalars["Int"]["input"]>;
  gte?: InputMaybe<Scalars["Int"]["input"]>;
  in?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  lt?: InputMaybe<Scalars["Int"]["input"]>;
  lte?: InputMaybe<Scalars["Int"]["input"]>;
  ne?: InputMaybe<Scalars["Int"]["input"]>;
  nil?: InputMaybe<Scalars["Boolean"]["input"]>;
  nin?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type Interval = {
  __typename?: "Interval";
  endingDate?: Maybe<Scalars["String"]["output"]>;
  eventCount?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  isInTerm?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  startingDate?: Maybe<Scalars["String"]["output"]>;
  termParts?: Maybe<Array<Maybe<TermPart>>>;
  usableInBookings?: Maybe<Scalars["Boolean"]["output"]>;
};

export type IntervalFilterInput = {
  fields?: InputMaybe<IntervalSearchFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type IntervalPage = {
  __typename?: "IntervalPage";
  items: Array<Interval>;
  pageInfo?: Maybe<PageInfo>;
};

export type IntervalRange = {
  __typename?: "IntervalRange";
  end?: Maybe<Interval>;
  start?: Maybe<Interval>;
};

export type IntervalSearchFieldsInput = {
  and?: InputMaybe<IntervalSearchFieldsInput>;
  dateRange?: InputMaybe<DateTimeRangeFilterInput>;
  endingDate?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  or?: InputMaybe<IntervalSearchFieldsInput>;
  searchTerm?: InputMaybe<Scalars["String"]["input"]>;
  startingDate?: InputMaybe<StringFilterInput>;
};

export type IntervalValidationErrors = {
  __typename?: "IntervalValidationErrors";
  interval?: Maybe<Interval>;
  validationErrors?: Maybe<Array<Maybe<EditorValidationError>>>;
};

export type IntervalsAssignmentNotAllowed = {
  __typename?: "IntervalsAssignmentNotAllowed";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type InvalidBlock = {
  __typename?: "InvalidBlock";
  isValidEndTime?: Maybe<Scalars["Boolean"]["output"]>;
  isValidStartTime?: Maybe<Scalars["Boolean"]["output"]>;
};

export type InvalidBlockForInstructor = {
  __typename?: "InvalidBlockForInstructor";
  blocks?: Maybe<Array<Maybe<Block>>>;
  instructor?: Maybe<Instructor>;
};

export type InvalidBuildingForCourse = {
  __typename?: "InvalidBuildingForCourse";
  allowedBuildings?: Maybe<Array<Maybe<Building>>>;
  building?: Maybe<Building>;
};

export type InvalidClassroomCapacity = {
  __typename?: "InvalidClassroomCapacity";
  capacity?: Maybe<Scalars["Int"]["output"]>;
  classroom: Classroom;
  reason?: Maybe<ValidationErrorReason>;
};

export type InvalidClassroomsCapacityAssignment = {
  __typename?: "InvalidClassroomsCapacityAssignment";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type InvalidComponentSize = {
  __typename?: "InvalidComponentSize";
  capacity?: Maybe<Scalars["Int"]["output"]>;
  component: CourseComponent;
  reason?: Maybe<ValidationErrorReason>;
};

export type InvalidDate = {
  __typename?: "InvalidDate";
  end?: Maybe<Scalars["String"]["output"]>;
  start?: Maybe<Scalars["String"]["output"]>;
};

export type InvalidExpectedBlocksByLink = {
  __typename?: "InvalidExpectedBlocksByLink";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  numberOfWeeks?: Maybe<Scalars["Int"]["output"]>;
  programmedBlocks?: Maybe<Scalars["Int"]["output"]>;
  totalBlocks?: Maybe<Scalars["Int"]["output"]>;
  weeklyBlocks?: Maybe<Scalars["Int"]["output"]>;
};

export type InvalidFieldValidation = {
  __typename?: "InvalidFieldValidation";
  meta?: Maybe<Scalars["String"]["output"]>;
  reason?: Maybe<ValidationErrorReason>;
  value: Scalars["String"]["output"];
};

export type InvalidGroupChanges = {
  __typename?: "InvalidGroupChanges";
  group: Group;
  validationErrors?: Maybe<Array<Maybe<GroupValidationErrorUnion>>>;
};

export type InvalidGroupCodeValidation = {
  __typename?: "InvalidGroupCodeValidation";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  reason?: Maybe<ValidationErrorReason>;
  rejected_groups?: Maybe<Array<Maybe<Group>>>;
};

export type InvalidGroupEnrollment = {
  __typename?: "InvalidGroupEnrollment";
  reason?: Maybe<ValidationErrorReason>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type InvalidInput = {
  __typename?: "InvalidInput";
  code?: Maybe<ValidationErrorReason>;
  meta?: Maybe<Scalars["String"]["output"]>;
};

export type InvalidInstructorContractedBlocks = {
  __typename?: "InvalidInstructorContractedBlocks";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  assigned?: Maybe<Scalars["Int"]["output"]>;
  component?: Maybe<Component>;
  contracted?: Maybe<Scalars["Int"]["output"]>;
  difference?: Maybe<Scalars["Int"]["output"]>;
  instructor?: Maybe<Instructor>;
};

export type InvalidInstructorTravel = InvalidTravel & {
  __typename?: "InvalidInstructorTravel";
  instructor?: Maybe<Instructor>;
  withFollowing?: Maybe<TravelClash>;
  withPrevious?: Maybe<TravelClash>;
};

export type InvalidInterval = {
  __typename?: "InvalidInterval";
  intervals?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
};

export type InvalidLabelLink = {
  __typename?: "InvalidLabelLink";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  link?: Maybe<Link>;
  reason?: Maybe<ValidationErrorReason>;
};

export type InvalidLinkChanges = {
  __typename?: "InvalidLinkChanges";
  groupChanges?: Maybe<Array<Maybe<InvalidGroupChanges>>>;
  link: Link;
  sectionChanges?: Maybe<Array<Maybe<InvalidSectionChanges>>>;
  sessionChanges?: Maybe<Array<Maybe<InvalidSessionChanges>>>;
};

export type InvalidLinksCourse = {
  __typename?: "InvalidLinksCourse";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  reason?: Maybe<ValidationErrorReason>;
};

export type InvalidLinksPackage = {
  __typename?: "InvalidLinksPackage";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  reason?: Maybe<ValidationErrorReason>;
};

export type InvalidPackageTravel = InvalidTravel & {
  __typename?: "InvalidPackageTravel";
  package?: Maybe<Package>;
  withFollowing?: Maybe<TravelClash>;
  withPrevious?: Maybe<TravelClash>;
};

export type InvalidPastSessionEdition = {
  __typename?: "InvalidPastSessionEdition";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  intervals?: Maybe<Array<Maybe<Interval>>>;
};

export type InvalidScheduledBlocksAssignment = {
  __typename?: "InvalidScheduledBlocksAssignment";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  assignedBlocks?: Maybe<Scalars["Int"]["output"]>;
  exceededBlocks?: Maybe<Scalars["Int"]["output"]>;
  plannedBlocks?: Maybe<Scalars["Int"]["output"]>;
  section?: Maybe<Section>;
};

export type InvalidSectionChanges = {
  __typename?: "InvalidSectionChanges";
  section: Section;
  validationErrors?: Maybe<Array<Maybe<SectionValidationErrorUnion>>>;
};

export type InvalidSessionChanges = {
  __typename?: "InvalidSessionChanges";
  session: Session;
  validationErrors?: Maybe<Array<Maybe<SessionValidationErrorUnion>>>;
};

export type InvalidSessionInHoliday = {
  __typename?: "InvalidSessionInHoliday";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  holiday?: Maybe<Array<Maybe<Holiday>>>;
};

export type InvalidSessionInHolidayDeletion = {
  __typename?: "InvalidSessionInHolidayDeletion";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  reason?: Maybe<Scalars["String"]["output"]>;
};

export type InvalidTotalExpectedBlocksByLink = {
  __typename?: "InvalidTotalExpectedBlocksByLink";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  difference?: Maybe<Scalars["Int"]["output"]>;
  expectedBlocks?: Maybe<Scalars["Int"]["output"]>;
  link?: Maybe<Link>;
  programmedBlocks?: Maybe<Scalars["Int"]["output"]>;
};

export type InvalidTravel = {
  withFollowing?: Maybe<TravelClash>;
  withPrevious?: Maybe<TravelClash>;
};

export type InvalidateSectionDeletion = {
  __typename?: "InvalidateSectionDeletion";
  code?: Maybe<ValidationErrorReason>;
};

export type Label = {
  __typename?: "Label";
  category: LabelCategory;
  code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type LabelCategory = {
  __typename?: "LabelCategory";
  code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  labelSource: LabelSource;
  name: Scalars["String"]["output"];
};

export type LabelCategoryFilterFieldsInput = {
  and?: InputMaybe<Array<LabelCategoryFilterFieldsInput>>;
  code?: InputMaybe<StringFilterInput>;
  contentType?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  labelSourceId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<LabelCategoryFilterFieldsInput>>;
};

export type LabelCategoryFilterInput = {
  fields?: InputMaybe<LabelCategoryFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type LabelCategoryPage = {
  __typename?: "LabelCategoryPage";
  items: Array<LabelCategory>;
  pageInfo?: Maybe<PageInfo>;
};

export type LabelFilterFieldsInput = {
  and?: InputMaybe<Array<LabelFilterFieldsInput>>;
  code?: InputMaybe<StringFilterInput>;
  contentType?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  labelCategoryId?: InputMaybe<IdFilterInput>;
  labelSourceCode?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<LabelFilterFieldsInput>>;
};

export type LabelFilterInput = {
  fields?: InputMaybe<LabelFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type LabelPage = {
  __typename?: "LabelPage";
  items: Array<Label>;
  pageInfo?: Maybe<PageInfo>;
};

export type LabelSource = {
  __typename?: "LabelSource";
  code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  sourceType: LabelSourceType;
};

export enum LabelSourceType {
  System = "SYSTEM",
  User = "USER",
}

export enum Language {
  En = "EN",
  Es = "ES",
}

export type Level = {
  __typename?: "Level";
  curriculum: Curriculum;
  id: Scalars["ID"]["output"];
  level: Scalars["Int"]["output"];
  maxCreditsPerTerm?: Maybe<Scalars["Int"]["output"]>;
  maxCreditsPerYear?: Maybe<Scalars["Int"]["output"]>;
  maxSubjectsPerTerm?: Maybe<Scalars["Int"]["output"]>;
  maxSubjectsPerYear?: Maybe<Scalars["Int"]["output"]>;
};

export type Link = {
  __typename?: "Link";
  blocksWithoutInstructorAssigment?: Maybe<Scalars["Int"]["output"]>;
  bundle?: Maybe<Bundle>;
  code?: Maybe<Scalars["String"]["output"]>;
  course?: Maybe<Course>;
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  groups?: Maybe<Array<Maybe<Group>>>;
  id: Scalars["ID"]["output"];
  /** @deprecated renamed. Use link field */
  instructorResponsability?: Maybe<Array<Maybe<InstructorLink>>>;
  instructors?: Maybe<Array<Maybe<InstructorLink>>>;
  label?: Maybe<Scalars["String"]["output"]>;
  origin: Origin;
  packages: Array<Package>;
  programmingStructure?: Maybe<ProgrammingStructure>;
  roleInPackages: Array<PackageSectionRole>;
  schedule?: Maybe<Schedule>;
  sections: Array<Section>;
  sectionsCount?: Maybe<Scalars["Int"]["output"]>;
  totalBlocks?: Maybe<Scalars["Int"]["output"]>;
  vacancies?: Maybe<Scalars["Int"]["output"]>;
};

export type LinkClash = EditorClash & {
  __typename?: "LinkClash";
  block?: Maybe<Block>;
  interval?: Maybe<Interval>;
  link?: Maybe<Link>;
  sessions?: Maybe<Array<Maybe<Session>>>;
};

export type LinkCrudChangesetInput = {
  creates?: InputMaybe<Array<InputMaybe<CreateLinkInput>>>;
  deletes?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  updates?: InputMaybe<Array<InputMaybe<UpdateLinkInput>>>;
};

export type LinkCrudInput = {
  /** the changes we want to perform in this operation */
  changesets?: InputMaybe<LinkCrudChangesetInput>;
  /** a rehearsal of a performance or procedure before the real one */
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** kip any validations that could cancel the operation */
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LinkCrudPayload = {
  __typename?: "LinkCrudPayload";
  creates?: Maybe<Array<Maybe<LinkPayload>>>;
  deletes?: Maybe<Array<Maybe<LinkPayload>>>;
  updates?: Maybe<Array<Maybe<LinkPayload>>>;
};

export type LinkCrudResult = {
  __typename?: "LinkCrudResult";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  payload?: Maybe<LinkCrudPayload>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  /** If user can skip some of the validations because has not assigned an ability */
  userCanSkipValidations?: Maybe<Scalars["Boolean"]["output"]>;
};

export type LinkFilter = {
  __typename?: "LinkFilter";
  id: Scalars["ID"]["output"];
  links?: Maybe<LinkPage>;
};

export type LinkFilterLinksArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type LinkFilterFieldsInput = {
  and?: InputMaybe<Array<LinkFilterFieldsInput>>;
  campusId?: InputMaybe<IntFilterInput>;
  course?: InputMaybe<CourseFilterFieldsInput>;
  courseId?: InputMaybe<IntFilterInput>;
  getUnrestrictedLinks?: InputMaybe<BooleanFilterInput>;
  or?: InputMaybe<Array<LinkFilterFieldsInput>>;
};

export type LinkFilterInput = {
  fields?: InputMaybe<LinkFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type LinkInfo = {
  __typename?: "LinkInfo";
  link?: Maybe<Link>;
};

export type LinkLogEntry = {
  __typename?: "LinkLogEntry";
  change?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  changeType?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  date?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  link?: Maybe<Link>;
  objectId?: Maybe<Scalars["ID"]["output"]>;
  resource?: Maybe<Scalars["String"]["output"]>;
  source?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<User>;
};

export type LinkLogEntryFilterFieldsInput = {
  and?: InputMaybe<Array<LinkLogEntryFilterFieldsInput>>;
  change?: InputMaybe<StringFilterInput>;
  changeType?: InputMaybe<StringFilterInput>;
  containsChanges?: InputMaybe<BooleanFilterInput>;
  date?: InputMaybe<StringFilterInput>;
  dateRange?: InputMaybe<DateAvailabilityFilterInput>;
  isOwner?: InputMaybe<BooleanFilterInput>;
  linkId?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<LinkLogEntryFilterFieldsInput>>;
  sessionId?: InputMaybe<IntFilterInput>;
  source?: InputMaybe<StringFilterInput>;
  userId?: InputMaybe<IntFilterInput>;
};

export type LinkLogEntryFilterInput = {
  fields?: InputMaybe<LinkLogEntryFilterFieldsInput>;
  orderBy?: InputMaybe<LinkLogEntryOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchBy?: InputMaybe<LinkLogEntrySearchTextToSearchByInputType>;
};

export enum LinkLogEntryOrderByFieldsEnum {
  Date = "date",
  Id = "id",
  LinkCode = "link_code",
  LinkId = "link_id",
  ObjectId = "object_id",
  ResourceChanges = "resource_changes",
  Source = "source",
  UserId = "user_id",
}

export type LinkLogEntryOrderByInput = {
  direction: OrderByDirection;
  field: LinkLogEntryOrderByFieldsEnum;
};

export type LinkLogEntryPage = {
  __typename?: "LinkLogEntryPage";
  items: Array<LinkLogEntry>;
  pageInfo?: Maybe<PageInfo>;
};

export enum LinkLogEntrySearchSearchableFieldsEnum {
  Date = "date",
  Id = "id",
  LinkCode = "link_code",
  LinkId = "link_id",
  ObjectId = "object_id",
  Source = "source",
  UserId = "user_id",
}

export type LinkLogEntrySearchTextToSearchByInputType = {
  fields?: InputMaybe<Array<InputMaybe<LinkLogEntrySearchSearchableFieldsEnum>>>;
  text?: InputMaybe<Scalars["String"]["input"]>;
};

export type LinkPage = {
  __typename?: "LinkPage";
  items: Array<Link>;
  pageInfo?: Maybe<PageInfo>;
};

export type LinkPayload = {
  __typename?: "LinkPayload";
  link?: Maybe<Link>;
  sections?: Maybe<Array<Maybe<Section>>>;
  validationErrors?: Maybe<Array<Maybe<EditorValidationError>>>;
};

export type LinkValidationErrorUnion = InvalidInput | InvalidSectionChanges;

export enum LocaleEnum {
  /** American English */
  EnUs = "en_US",
  /** Latin American Spanish */
  EsMx = "es_MX",
}

export type MicroprogrammingInstanceInput = {
  blocksCount?: InputMaybe<Scalars["Int"]["input"]>;
  blocksIds: Array<Scalars["ID"]["input"]>;
  classroomIds: Array<Scalars["ID"]["input"]>;
  date?: InputMaybe<Scalars["String"]["input"]>;
  day?: InputMaybe<Scalars["String"]["input"]>;
  dayId?: InputMaybe<Scalars["Int"]["input"]>;
  endingTime: Scalars["String"]["input"];
  instructorIds: Array<Scalars["ID"]["input"]>;
  intervalId: Scalars["ID"]["input"];
  originSectionId?: InputMaybe<Scalars["ID"]["input"]>;
  originSessionId?: InputMaybe<Scalars["ID"]["input"]>;
  startingTime: Scalars["String"]["input"];
};

export type MicroprogrammingPreviewAssignment = {
  __typename?: "MicroprogrammingPreviewAssignment";
  blockRange?: Maybe<BlockRange>;
  blocks: Array<Block>;
  day?: Maybe<Day>;
  intervals: Array<Interval>;
};

export enum MicroprogrammingPreviewErrorCode {
  BlockNotFound = "BLOCK_NOT_FOUND",
  ClassroomNotFound = "CLASSROOM_NOT_FOUND",
  ComponentNotFound = "COMPONENT_NOT_FOUND",
  InstructorNotFound = "INSTRUCTOR_NOT_FOUND",
  IntervalNotFound = "INTERVAL_NOT_FOUND",
  ProgrammingStructureNotFound = "PROGRAMMING_STRUCTURE_NOT_FOUND",
  UnknownStageCode = "UNKNOWN_STAGE_CODE",
}

export type MicroprogrammingPreviewInput = {
  instancesByStage: Array<StageInstancesInput>;
  programmingStructureId: Scalars["ID"]["input"];
};

export type MicroprogrammingPreviewResult = {
  __typename?: "MicroprogrammingPreviewResult";
  sections: Array<MicroprogrammingPreviewSection>;
  validationErrors: Array<MicroprogrammingPreviewValidationError>;
};

export type MicroprogrammingPreviewSection = {
  __typename?: "MicroprogrammingPreviewSection";
  code: Scalars["String"]["output"];
  component?: Maybe<Component>;
  id: Scalars["ID"]["output"];
  isPreview?: Maybe<Scalars["Boolean"]["output"]>;
  sessions: Array<MicroprogrammingPreviewSession>;
};

export type MicroprogrammingPreviewSession = {
  __typename?: "MicroprogrammingPreviewSession";
  assignment?: Maybe<MicroprogrammingPreviewAssignment>;
  blocksCount?: Maybe<Scalars["Int"]["output"]>;
  classrooms: Array<Classroom>;
  id: Scalars["ID"]["output"];
  instructors: Array<Instructor>;
  isPreview?: Maybe<Scalars["Boolean"]["output"]>;
};

export type MicroprogrammingPreviewValidationError = {
  __typename?: "MicroprogrammingPreviewValidationError";
  code: MicroprogrammingPreviewErrorCode;
  message?: Maybe<Scalars["String"]["output"]>;
};

export type Modality = {
  __typename?: "Modality";
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ModalityFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<ModalityFilterFieldsInput>>>;
  code?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModalityFilterFieldsInput>>>;
};

export type ModalityFilterInput = {
  fields?: InputMaybe<ModalityFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
  ignoreAccessFilters?: Scalars["Boolean"]["input"];
};

export type ModalityPage = {
  __typename?: "ModalityPage";
  items: Array<Modality>;
  pageInfo?: Maybe<PageInfo>;
};

export type ModelExtension = {
  __typename?: "ModelExtension";
  contentType?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  order?: Maybe<Scalars["Int"]["output"]>;
  tag?: Maybe<Tag>;
};

export type ModelExtensionFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<ModelExtensionFilterFieldsInput>>>;
  contentType?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelExtensionFilterFieldsInput>>>;
};

export type ModelExtensionFilterInput = {
  fields?: InputMaybe<ModelExtensionFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ModelExtensionPage = {
  __typename?: "ModelExtensionPage";
  items: Array<ModelExtension>;
  pageInfo?: Maybe<PageInfo>;
};

export type Module = {
  __typename?: "Module";
  accesible?: Maybe<Scalars["Boolean"]["output"]>;
  code: Scalars["String"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
};

export type ModuleAccesibleArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  auth?: Maybe<User>;
  base?: Maybe<BaseMutation>;
  cube?: Maybe<CubeMutation>;
  filter?: Maybe<FilterMutation>;
  login?: Maybe<User>;
};

export type MutationAuthArgs = {
  token: Scalars["String"]["input"];
};

export type MutationCubeArgs = {
  originId?: InputMaybe<Scalars["ID"]["input"]>;
  scenarioId: Scalars["ID"]["input"];
};

export type MutationFilterArgs = {
  originId: Scalars["ID"]["input"];
  scenarioId: Scalars["ID"]["input"];
};

export type MutationLoginArgs = {
  password: Scalars["String"]["input"];
  username: Scalars["String"]["input"];
};

export type OnOffFeatures = {
  __typename?: "OnOffFeatures";
  groupText?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum OrderByDirection {
  Asc = "ASC",
  Desc = "DESC",
}

export type Origin = {
  __typename?: "Origin";
  demandCount?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  isProductive?: Maybe<Scalars["Boolean"]["output"]>;
  isProtected?: Maybe<Scalars["Boolean"]["output"]>;
  isReal?: Maybe<Scalars["Boolean"]["output"]>;
  isVisible?: Maybe<Scalars["Boolean"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  term?: Maybe<Term>;
};

export type OriginInput = {
  hasDemands?: InputMaybe<Scalars["Boolean"]["input"]>;
  isProductive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  processTypeId?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  type?: InputMaybe<OriginType>;
};

export enum OriginType {
  Assignation = "ASSIGNATION",
  DataManager = "DATA_MANAGER",
  DemandForecast = "DEMAND_FORECAST",
  DemandFreshmen = "DEMAND_FRESHMEN",
  DemandPlanning = "DEMAND_PLANNING",
  DemandReEnrollment = "DEMAND_RE_ENROLLMENT",
  Enrollment = "ENROLLMENT",
  Record = "RECORD",
  Sections = "SECTIONS",
}

export type Package = {
  __typename?: "Package";
  code?: Maybe<Scalars["String"]["output"]>;
  complete?: Maybe<Scalars["Boolean"]["output"]>;
  completingLinks: Array<Link>;
  hasPackageRules?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  index: Scalars["Int"]["output"];
  isPublished?: Maybe<Scalars["Boolean"]["output"]>;
  isReplicated?: Maybe<Scalars["Boolean"]["output"]>;
  isVisible?: Maybe<Scalars["Boolean"]["output"]>;
  labels?: Maybe<Array<Maybe<Label>>>;
  links: Array<Link>;
  name?: Maybe<Scalars["String"]["output"]>;
  origin: Origin;
  packageTotalCredits?: Maybe<Scalars["Float"]["output"]>;
  population: Population;
  schedule?: Maybe<Schedule>;
  sourcePackage?: Maybe<Package>;
  sourcePopulationCode?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  vacancies: Scalars["Int"]["output"];
  vacanciesSource?: Maybe<Scalars["String"]["output"]>;
};

export type PackageClash = EditorClash & {
  __typename?: "PackageClash";
  block?: Maybe<Block>;
  interval?: Maybe<Interval>;
  package?: Maybe<Package>;
  sessions?: Maybe<Array<Maybe<Session>>>;
};

export type PackageCrudChangesetInput = {
  creates?: InputMaybe<Array<InputMaybe<CreatePackageInput>>>;
  deletes?: InputMaybe<Array<InputMaybe<DeletePackageInput>>>;
  updates?: InputMaybe<Array<InputMaybe<EditPackageInput>>>;
};

export type PackageCrudInput = {
  /** the changes we want to perform in this operation */
  changesets?: InputMaybe<PackageCrudChangesetInput>;
  /** a rehearsal of a performance or procedure before the real one */
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** kip any validations that could cancel the operation */
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PackageCrudPayload = {
  __typename?: "PackageCrudPayload";
  creates?: Maybe<Array<Maybe<PackagePayload>>>;
  deletes?: Maybe<Array<Maybe<PackagePayload>>>;
  updates?: Maybe<Array<Maybe<PackagePayload>>>;
};

export type PackageCrudResult = {
  __typename?: "PackageCrudResult";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  payload?: Maybe<PackageCrudPayload>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  /** If user can skip some of the validations because has not assigned an ability */
  userCanSkipValidations?: Maybe<Scalars["Boolean"]["output"]>;
};

export type PackageFilter = {
  __typename?: "PackageFilter";
  id: Scalars["ID"]["output"];
  packages?: Maybe<PackagePage>;
};

export type PackageFilterPackagesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type PackageFilterFieldsInput = {
  and?: InputMaybe<Array<PackageFilterFieldsInput>>;
  hasEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPublished?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<LabelFilterFieldsInput>;
  or?: InputMaybe<Array<PackageFilterFieldsInput>>;
  population?: InputMaybe<PopulationFilterFieldsInput>;
};

export type PackageFilterInput = {
  fields?: InputMaybe<PackageFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type PackageInfo = {
  __typename?: "PackageInfo";
  package?: Maybe<Package>;
};

export type PackageLinkAssignmentInput = {
  /** the changes we want to perform in this operation */
  changesets?: InputMaybe<PackageCrudChangesetInput>;
  /** a rehearsal of a performance or procedure before the real one */
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** kip any validations that could cancel the operation */
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PackageLinkAssignmentResult = {
  __typename?: "PackageLinkAssignmentResult";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  payload?: Maybe<PackageCrudPayload>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  /** If user can skip some of the validations because has not assigned an ability */
  userCanSkipValidations?: Maybe<Scalars["Boolean"]["output"]>;
};

export type PackageNotPublished = {
  __typename?: "PackageNotPublished";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  reason?: Maybe<ValidationErrorReason>;
};

export type PackagePage = {
  __typename?: "PackagePage";
  items: Array<Package>;
  pageInfo?: Maybe<PageInfo>;
};

export type PackagePayload = {
  __typename?: "PackagePayload";
  link?: Maybe<Link>;
  package?: Maybe<Package>;
  replicatedPackages?: Maybe<Array<Maybe<Package>>>;
  validationErrors?: Maybe<Array<Maybe<EditorValidationError>>>;
};

export type PackagePublishingDisabled = {
  __typename?: "PackagePublishingDisabled";
  allowed?: Maybe<Scalars["Boolean"]["output"]>;
  reason?: Maybe<ValidationErrorReason>;
};

export type PackageSectionRole = {
  __typename?: "PackageSectionRole";
  id: Scalars["ID"]["output"];
  isCompleting: Scalars["Boolean"]["output"];
  link: Link;
  package: Package;
};

export type PageInfo = {
  __typename?: "PageInfo";
  hasNextPage?: Maybe<Scalars["Boolean"]["output"]>;
  hasPreviousPage?: Maybe<Scalars["Boolean"]["output"]>;
  page?: Maybe<Scalars["Int"]["output"]>;
  size?: Maybe<Scalars["Int"]["output"]>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type PaginationInput = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  searchTerm?: InputMaybe<Scalars["String"]["input"]>;
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Population = {
  __typename?: "Population";
  campus: Campus;
  code?: Maybe<Scalars["String"]["output"]>;
  courses?: Maybe<Array<Maybe<Course>>>;
  curriculum?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  labels?: Maybe<Array<Maybe<Label>>>;
  level?: Maybe<Scalars["Int"]["output"]>;
  modality: Modality;
  origin?: Maybe<Origin>;
  packageCount?: Maybe<Scalars["Int"]["output"]>;
  packageIndex?: Maybe<Scalars["Int"]["output"]>;
  program: Program;
  shift: Shift;
  size?: Maybe<Scalars["Int"]["output"]>;
  term: Term;
};

export type PopulationFilter = {
  __typename?: "PopulationFilter";
  id: Scalars["ID"]["output"];
  populations?: Maybe<PopulationPage>;
};

export type PopulationFilterPopulationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type PopulationFilterFieldsInput = {
  and?: InputMaybe<Array<PopulationFilterFieldsInput>>;
  campusId?: InputMaybe<IdFilterInput>;
  curriculum?: InputMaybe<StringFilterInput>;
  curriculumId?: InputMaybe<IdFilterInput>;
  departmentId?: InputMaybe<IdFilterInput>;
  hasEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
  level?: InputMaybe<IntFilterInput>;
  modalityId?: InputMaybe<IdFilterInput>;
  or?: InputMaybe<Array<PopulationFilterFieldsInput>>;
  program?: InputMaybe<ProgramFilterFieldsInput>;
  programId?: InputMaybe<IdFilterInput>;
  shiftId?: InputMaybe<IdFilterInput>;
};

export type PopulationFilterInput = {
  fields?: InputMaybe<PopulationFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type PopulationInfo = {
  __typename?: "PopulationInfo";
  population?: Maybe<Population>;
};

export type PopulationPage = {
  __typename?: "PopulationPage";
  items: Array<Population>;
  pageInfo?: Maybe<PageInfo>;
};

export type PreferencesInput = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  locale?: InputMaybe<LocaleEnum>;
  savedContext?: InputMaybe<CubeContextInput>;
  theme?: InputMaybe<ThemeEnum>;
};

export type PreferencesType = {
  __typename?: "PreferencesType";
  cubeContext?: Maybe<CubeContext>;
  locale?: Maybe<Scalars["String"]["output"]>;
  theme?: Maybe<Scalars["String"]["output"]>;
};

export type ProcessStat = {
  __typename?: "ProcessStat";
  attributes?: Maybe<ProcessStatAttribute>;
  id?: Maybe<Scalars["ID"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  moduleType?: Maybe<Scalars["String"]["output"]>;
  processId?: Maybe<Scalars["ID"]["output"]>;
  processType?: Maybe<Scalars["String"]["output"]>;
  scenario?: Maybe<Scenario>;
  scenarioId?: Maybe<Scalars["ID"]["output"]>;
  stats?: Maybe<Scalars["String"]["output"]>;
};

export type ProcessStatAttribute = {
  __typename?: "ProcessStatAttribute";
  isProductive: Scalars["Boolean"]["output"];
  isProtected: Scalars["Boolean"]["output"];
  isReal: Scalars["Boolean"]["output"];
  isVisible: Scalars["Boolean"]["output"];
};

export type ProcessStatFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<ProcessStatFilterFieldsInput>>>;
  attributes?: InputMaybe<AttributesFilterFieldsInput>;
  label?: InputMaybe<StringFilterInput>;
  moduleType?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ProcessStatFilterFieldsInput>>>;
  processId?: InputMaybe<IdFilterInput>;
  processType?: InputMaybe<StringFilterInput>;
  scenarioId?: InputMaybe<IdFilterInput>;
};

export type ProcessStatFilterInput = {
  fields?: InputMaybe<ProcessStatFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ProcessStatPageType = {
  __typename?: "ProcessStatPageType";
  items: Array<ProcessStat>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductConfiguration = {
  __typename?: "ProductConfiguration";
  accesible?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  path?: Maybe<Scalars["String"]["output"]>;
  permissions?: Maybe<UserPermissionsAction>;
};

export type ProductConfigurationAccesibleArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ProductConfigurationPermissionsArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type Program = {
  __typename?: "Program";
  campus?: Maybe<Campus>;
  code?: Maybe<Scalars["String"]["output"]>;
  curriculums?: Maybe<Array<Maybe<Curriculum>>>;
  department?: Maybe<Department>;
  id: Scalars["ID"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  modality?: Maybe<Modality>;
  name?: Maybe<Scalars["String"]["output"]>;
  shift?: Maybe<Shift>;
};

export type ProgramFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<ProgramFilterFieldsInput>>>;
  campusId?: InputMaybe<IdFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  curriculums?: InputMaybe<CurriculumFilterFieldsInput>;
  department?: InputMaybe<DepartmentFilterFieldsInput>;
  departmentId?: InputMaybe<IdFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  modalityId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ProgramFilterFieldsInput>>>;
  shiftId?: InputMaybe<IdFilterInput>;
};

export type ProgramFilterInput = {
  fields?: InputMaybe<ProgramFilterFieldsInput>;
  groupByCode?: InputMaybe<Scalars["Boolean"]["input"]>;
  orderByCodeAndName?: InputMaybe<Scalars["Boolean"]["input"]>;
  pagination?: InputMaybe<PaginationInput>;
  ignoreAccessFilters?: Scalars["Boolean"]["input"];
};

export type ProgramPage = {
  __typename?: "ProgramPage";
  items: Array<Program>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProgrammingStructure = {
  __typename?: "ProgrammingStructure";
  campusCodes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  programmingStructureParts?: Maybe<Array<Maybe<ProgrammingStructurePart>>>;
  programmingStructureStats?: Maybe<ProgrammingStructureStats>;
  source?: Maybe<Scalars["String"]["output"]>;
  subjectCodes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  totalBlockDuration?: Maybe<Scalars["Int"]["output"]>;
};

/** Filter by codes stored as a JSON string array on the structure. If both in and nin are set, both apply (AND). */
export type ProgrammingStructureCodesFilterInput = {
  /** Match if the structure JSON array contains any of these codes (OR). */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Match only if the structure JSON array contains none of these codes. */
  nin?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ProgrammingStructureCrudChangesetInput = {
  creates?: InputMaybe<Array<InputMaybe<CreateProgrammingStructureInput>>>;
  deletes?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  updates?: InputMaybe<Array<InputMaybe<UpdateProgrammingStructureInput>>>;
};

export type ProgrammingStructureCrudInput = {
  /** the changes we want to perform in this operation */
  changesets?: InputMaybe<ProgrammingStructureCrudChangesetInput>;
  /** a rehearsal of a performance or procedure before the real one */
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** skip any validations that could cancel the operation */
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProgrammingStructureCrudPayload = {
  __typename?: "ProgrammingStructureCrudPayload";
  creates?: Maybe<Array<Maybe<ProgrammingStructurePayload>>>;
  deletes?: Maybe<Array<Maybe<ProgrammingStructurePayload>>>;
  updates?: Maybe<Array<Maybe<ProgrammingStructurePayload>>>;
};

export type ProgrammingStructureCrudResult = {
  __typename?: "ProgrammingStructureCrudResult";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  payload?: Maybe<ProgrammingStructureCrudPayload>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  /** If user can skip some of the validations because has not assigned an ability */
  userCanSkipValidations?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ProgrammingStructureDependencyCodeNotInStructure = {
  __typename?: "ProgrammingStructureDependencyCodeNotInStructure";
  dependencyCode?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  programmingStructurePartCode?: Maybe<Scalars["String"]["output"]>;
  reason?: Maybe<ProgrammingStructureValidationReason>;
};

export type ProgrammingStructureDuplicateCodeSubject = {
  __typename?: "ProgrammingStructureDuplicateCodeSubject";
  code?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  reason?: Maybe<ProgrammingStructureValidationReason>;
  subjectCodes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type ProgrammingStructureFilterFieldsInput = {
  and?: InputMaybe<Array<ProgrammingStructureFilterFieldsInput>>;
  campusCodes?: InputMaybe<ProgrammingStructureCodesFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  /** To search by a set of fields related to programming structures */
  fullText?: InputMaybe<Scalars["String"]["input"]>;
  isPublished?: InputMaybe<BooleanFilterInput>;
  isVisible?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ProgrammingStructureFilterFieldsInput>>;
  source?: InputMaybe<StringFilterInput>;
  subjectCodes?: InputMaybe<ProgrammingStructureCodesFilterInput>;
};

export type ProgrammingStructureFilterInput = {
  fields?: InputMaybe<ProgrammingStructureFilterFieldsInput>;
  orderBy?: InputMaybe<Array<InputMaybe<ProgrammingStructureOrderByInput>>>;
  pagination?: InputMaybe<PaginationInput>;
};

export enum ProgrammingStructureOrderByFields {
  Code = "code",
  CreatedAt = "createdAt",
  Id = "id",
  IsPublished = "isPublished",
  IsVisible = "isVisible",
  Name = "name",
  Source = "source",
  SubjectCodes = "subjectCodes",
  UpdatedAt = "updatedAt",
}

export type ProgrammingStructureOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field: ProgrammingStructureOrderByFields;
};

export type ProgrammingStructurePage = {
  __typename?: "ProgrammingStructurePage";
  items: Array<ProgrammingStructure>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProgrammingStructurePart = {
  __typename?: "ProgrammingStructurePart";
  blockDuration?: Maybe<Scalars["Int"]["output"]>;
  code?: Maybe<Scalars["String"]["output"]>;
  dependenciesCodes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  programmingStructureStage?: Maybe<ProgrammingStructureStage>;
  references?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type ProgrammingStructurePayload = {
  __typename?: "ProgrammingStructurePayload";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  structure?: Maybe<ProgrammingStructure>;
  validationErrors?: Maybe<Array<Maybe<ProgrammingStructureValidationError>>>;
};

export type ProgrammingStructureStage = {
  __typename?: "ProgrammingStructureStage";
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  programmingStructureStageType?: Maybe<ProgrammingStructureStageType>;
};

export type ProgrammingStructureStageFilterInput = {
  pagination?: InputMaybe<PaginationInput>;
};

export type ProgrammingStructureStageNotFound = {
  __typename?: "ProgrammingStructureStageNotFound";
  programmingStructurePartCode?: Maybe<Scalars["String"]["output"]>;
  programmingStructureStageId?: Maybe<Scalars["ID"]["output"]>;
  reason?: Maybe<ProgrammingStructureValidationReason>;
};

export type ProgrammingStructureStagePage = {
  __typename?: "ProgrammingStructureStagePage";
  items: Array<ProgrammingStructureStage>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProgrammingStructureStageType = {
  __typename?: "ProgrammingStructureStageType";
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ProgrammingStructureStats = {
  __typename?: "ProgrammingStructureStats";
  id: Scalars["ID"]["output"];
  isPublished?: Maybe<Scalars["Boolean"]["output"]>;
  isVisible?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ProgrammingStructureValidation = {
  __typename?: "ProgrammingStructureValidation";
  code?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  reason?: Maybe<ProgrammingStructureValidationReason>;
};

export type ProgrammingStructureValidationError =
  | ProgrammingStructureDependencyCodeNotInStructure
  | ProgrammingStructureDuplicateCodeSubject
  | ProgrammingStructureStageNotFound
  | ProgrammingStructureValidation;

export enum ProgrammingStructureValidationReason {
  ProgrammingStructureAtLeastOnePart = "PROGRAMMING_STRUCTURE_AT_LEAST_ONE_PART",
  ProgrammingStructureCampusCodeNotFound = "PROGRAMMING_STRUCTURE_CAMPUS_CODE_NOT_FOUND",
  ProgrammingStructureCircularDependency = "PROGRAMMING_STRUCTURE_CIRCULAR_DEPENDENCY",
  ProgrammingStructureDependencyCodeNotInStructure = "PROGRAMMING_STRUCTURE_DEPENDENCY_CODE_NOT_IN_STRUCTURE",
  ProgrammingStructureDuplicateCodeSubject = "PROGRAMMING_STRUCTURE_DUPLICATE_CODE_SUBJECT",
  ProgrammingStructureNotFound = "PROGRAMMING_STRUCTURE_NOT_FOUND",
  ProgrammingStructurePublishedCannotDelete = "PROGRAMMING_STRUCTURE_PUBLISHED_CANNOT_DELETE",
  ProgrammingStructurePublishedCannotEdit = "PROGRAMMING_STRUCTURE_PUBLISHED_CANNOT_EDIT",
  ProgrammingStructureStageNotFound = "PROGRAMMING_STRUCTURE_STAGE_NOT_FOUND",
  ProgrammingStructureSubjectCodeNotFound = "PROGRAMMING_STRUCTURE_SUBJECT_CODE_NOT_FOUND",
  ProgrammingStructureUnpublishedCannotBeVisible = "PROGRAMMING_STRUCTURE_UNPUBLISHED_CANNOT_BE_VISIBLE",
}

export type Query = {
  __typename?: "Query";
  base?: Maybe<BaseQuery>;
  cube?: Maybe<CubeQuery>;
  data?: Maybe<DataQuery>;
  filter?: Maybe<FilterQuery>;
};

export type QueryCubeArgs = {
  originId?: InputMaybe<Scalars["ID"]["input"]>;
  scenarioId: Scalars["ID"]["input"];
};

export type QueryDataArgs = {
  originId?: InputMaybe<Scalars["ID"]["input"]>;
  scenarioId: Scalars["ID"]["input"];
};

export type QueryFilterArgs = {
  scenarioId: Scalars["ID"]["input"];
};

export type Recommendation = {
  __typename?: "Recommendation";
  alternatives?: Maybe<Array<Maybe<RecommendationAlternatives>>>;
  process_id: Scalars["ID"]["output"];
  session?: Maybe<Session>;
};

export type RecommendationAlternatives = {
  __typename?: "RecommendationAlternatives";
  assignedInstructors?: Maybe<Array<Maybe<Instructor>>>;
  classrooms?: Maybe<Array<Maybe<Classroom>>>;
  current_asignment_mark?: Maybe<Scalars["Boolean"]["output"]>;
  days?: Maybe<DayLegacy>;
  instructors?: Maybe<Array<Maybe<Instructor>>>;
  start_time?: Maybe<Scalars["String"]["output"]>;
};

export type Reference = {
  __typename?: "Reference";
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  meta?: Maybe<Scalars["String"]["output"]>;
  referenceCategory?: Maybe<ReferenceCategory>;
  referenceCategoryId: Scalars["ID"]["output"];
  value: Scalars["String"]["output"];
};

export type ReferenceCategory = {
  __typename?: "ReferenceCategory";
  code: Scalars["String"]["output"];
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  references?: Maybe<Array<Maybe<Reference>>>;
};

export type ReferenceCategoryFilterFieldsInput = {
  and?: InputMaybe<Array<ReferenceCategoryFilterFieldsInput>>;
  code?: InputMaybe<StringFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ReferenceCategoryFilterFieldsInput>>;
};

export type ReferenceCategoryFilterInput = {
  fields?: InputMaybe<ReferenceCategoryFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ReferenceCategoryPage = {
  __typename?: "ReferenceCategoryPage";
  items: Array<ReferenceCategory>;
  pageInfo?: Maybe<PageInfo>;
};

export type ReferenceFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<ReferenceFilterFieldsInput>>>;
  id?: InputMaybe<IdFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ReferenceFilterFieldsInput>>>;
  referenceCategory?: InputMaybe<ReferenceCategoryFilterFieldsInput>;
  referenceCategoryId?: InputMaybe<IdFilterInput>;
  value?: InputMaybe<StringFilterInput>;
};

export type ReferenceFilterInput = {
  fields?: InputMaybe<ReferenceFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ReferencePage = {
  __typename?: "ReferencePage";
  items: Array<Reference>;
  pageInfo?: Maybe<PageInfo>;
};

export type Report = {
  __typename?: "Report";
  accesible?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  path?: Maybe<Scalars["String"]["output"]>;
  permissions?: Maybe<UserPermissionsAction>;
};

export type ReportAccesibleArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ReportPermissionsArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ResourceAssigment = {
  __typename?: "ResourceAssigment";
  classroom?: Maybe<Scalars["Boolean"]["output"]>;
  instructor?: Maybe<Scalars["Boolean"]["output"]>;
  schedule?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum ResourceType {
  Classroom = "CLASSROOM",
  Course = "COURSE",
  Group = "GROUP",
  Instructor = "INSTRUCTOR",
  Link = "LINK",
  Package = "PACKAGE",
  Population = "POPULATION",
  Section = "SECTION",
}

export enum RestrictionType {
  InstructorAvailability = "INSTRUCTOR_AVAILABILITY",
  Strip = "STRIP",
}

export type Role = {
  __typename?: "Role";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type Scenario = {
  __typename?: "Scenario";
  category?: Maybe<ScenarioCategory>;
  code: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  origins?: Maybe<Array<Maybe<Origin>>>;
  productiveOrigin?: Maybe<Origin>;
  status?: Maybe<ScenarioStatus>;
  workspace?: Maybe<Workspace>;
};

export type ScenarioOriginsArgs = {
  isProductive?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ScenarioCategory = {
  __typename?: "ScenarioCategory";
  id: Scalars["ID"]["output"];
  value: Scalars["String"]["output"];
};

export type ScenarioConfiguration = {
  __typename?: "ScenarioConfiguration";
  accesible?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  path?: Maybe<Scalars["String"]["output"]>;
  permissions?: Maybe<UserPermissionsAction>;
};

export type ScenarioConfigurationAccesibleArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ScenarioConfigurationPermissionsArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ScenarioStatus = {
  __typename?: "ScenarioStatus";
  id: Scalars["ID"]["output"];
  value: Scalars["String"]["output"];
};

export enum ScenarioStatusEnum {
  Dislocked = "DISLOCKED",
  Locked = "LOCKED",
  Productive = "PRODUCTIVE",
}

export type ScenariosInput = {
  status?: InputMaybe<ScenarioStatusEnum>;
  workspaceId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type Schedule = {
  __typename?: "Schedule";
  resourceAssigment?: Maybe<ResourceAssigment>;
  sessions?: Maybe<Array<Maybe<Session>>>;
  summaryByDay?: Maybe<Array<Maybe<DayTimeRange>>>;
};

export type ScheduleEvent = {
  __typename?: "ScheduleEvent";
  colorIndex?: Maybe<Scalars["Int"]["output"]>;
  end?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  start?: Maybe<Scalars["String"]["output"]>;
};

export type ScheduleInstance = {
  __typename?: "ScheduleInstance";
  date: Scalars["String"]["output"];
  day: Scalars["String"]["output"];
  endingTime: Scalars["String"]["output"];
  interval: Interval;
  sections?: Maybe<Array<Maybe<ScheduleInstanceSection>>>;
  startingTime: Scalars["String"]["output"];
};

export type ScheduleInstanceFilterFieldsInput = {
  linkId: IdFilterInput;
};

export type ScheduleInstanceFilterInput = {
  fields: ScheduleInstanceFilterFieldsInput;
  orderBy?: InputMaybe<Array<InputMaybe<ScheduleInstanceOrderByInput>>>;
};

export enum ScheduleInstanceOrderByFields {
  Date = "date",
}

export type ScheduleInstanceOrderByInput = {
  direction: OrderByDirection;
  field: ScheduleInstanceOrderByFields;
};

export type ScheduleInstanceSection = {
  __typename?: "ScheduleInstanceSection";
  code?: Maybe<Scalars["String"]["output"]>;
  component?: Maybe<Component>;
  id?: Maybe<Scalars["ID"]["output"]>;
  sessions?: Maybe<Array<Maybe<ScheduleInstanceSession>>>;
};

export type ScheduleInstanceSession = {
  __typename?: "ScheduleInstanceSession";
  blocks?: Maybe<Array<Maybe<Block>>>;
  blocksCount?: Maybe<Scalars["Int"]["output"]>;
  classrooms?: Maybe<Array<Maybe<Classroom>>>;
  id: Scalars["ID"]["output"];
  instructors?: Maybe<Array<Maybe<Instructor>>>;
};

export type ScheduleRestrictionEvent = {
  __typename?: "ScheduleRestrictionEvent";
  dayId?: Maybe<Scalars["String"]["output"]>;
  end?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  start?: Maybe<Scalars["String"]["output"]>;
};

export type Section = {
  __typename?: "Section";
  buildings: Array<Building>;
  bundle?: Maybe<Bundle>;
  code?: Maybe<Scalars["String"]["output"]>;
  component?: Maybe<Component>;
  course?: Maybe<Course>;
  courseComponent?: Maybe<CourseComponent>;
  groups?: Maybe<Array<Maybe<Group>>>;
  id: Scalars["ID"]["output"];
  labels?: Maybe<Array<Maybe<Label>>>;
  links?: Maybe<Array<Maybe<Link>>>;
  linksByBundles?: Maybe<Array<Maybe<Link>>>;
  linksByGroup?: Maybe<Array<Maybe<Link>>>;
  origin: Origin;
  schedule?: Maybe<Schedule>;
  sessions: Array<Session>;
  totalBlocks?: Maybe<Scalars["Int"]["output"]>;
  unasignedSessions?: Maybe<Array<Maybe<Session>>>;
  usedCapacity?: Maybe<Scalars["Int"]["output"]>;
  vacancies?: Maybe<Scalars["Int"]["output"]>;
  waitingListsCount?: Maybe<Scalars["Int"]["output"]>;
};

export type SectionLinksByBundlesArgs = {
  bundleId: Scalars["ID"]["input"];
};

export type SectionLinksByGroupArgs = {
  groupId: Scalars["ID"]["input"];
};

export type SectionChangesetInput = {
  changeCourseComponent?: InputMaybe<ChangeCourseComponentInputType>;
};

export type SectionClash = EditorClash & {
  __typename?: "SectionClash";
  block?: Maybe<Block>;
  interval?: Maybe<Interval>;
  section?: Maybe<Section>;
  sessions?: Maybe<Array<Maybe<Session>>>;
};

export type SectionFilter = {
  __typename?: "SectionFilter";
  id: Scalars["ID"]["output"];
  sections?: Maybe<SectionPage>;
};

export type SectionFilterSectionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type SectionFilterFieldsInput = {
  and?: InputMaybe<Array<SectionFilterFieldsInput>>;
  assignment?: InputMaybe<AssignmentFilterInput>;
  availability?: InputMaybe<AvailabilityFilterInput>;
  clashes?: InputMaybe<ClashesFilterInput>;
  course?: InputMaybe<CourseFilterFieldsInput>;
  courseComponentId?: InputMaybe<IntFilterInput>;
  courseId?: InputMaybe<IntFilterInput>;
  curriculumId?: InputMaybe<IdFilterInput>;
  filterAccessCode?: InputMaybe<Scalars["Boolean"]["input"]>;
  level?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<SectionFilterFieldsInput>>;
  program?: InputMaybe<ProgramFilterFieldsInput>;
};

export type SectionFilterInput = {
  fields?: InputMaybe<SectionFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type SectionInfo = {
  __typename?: "SectionInfo";
  campus?: Maybe<Campus>;
  course?: Maybe<Course>;
  courseComponent?: Maybe<CourseComponent>;
  curriculum?: Maybe<Curriculum>;
  department?: Maybe<Department>;
  modality?: Maybe<Modality>;
  packages?: Maybe<Array<Maybe<Package>>>;
  program?: Maybe<Program>;
  section?: Maybe<Section>;
  shift?: Maybe<Shift>;
};

export type SectionPage = {
  __typename?: "SectionPage";
  items: Array<Section>;
  pageInfo?: Maybe<PageInfo>;
};

export type SectionValidationErrorUnion =
  | ExternalGroupValidation
  | InvalidComponentSize
  | InvalidGroupEnrollment
  | InvalidInput
  | InvalidateSectionDeletion;

export type Session = {
  __typename?: "Session";
  assignment?: Maybe<SessionAssignment>;
  blocksCount?: Maybe<Scalars["Int"]["output"]>;
  classrooms?: Maybe<Array<Maybe<Classroom>>>;
  events: Array<Event>;
  hasValidationErrors?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  instructors?: Maybe<Array<Maybe<Instructor>>>;
  labels?: Maybe<Array<Maybe<Label>>>;
  links?: Maybe<Array<Maybe<Link>>>;
  origin: Origin;
  schedule?: Maybe<Schedule>;
  scheduleEvent?: Maybe<Array<Maybe<ScheduleEvent>>>;
  section?: Maybe<Section>;
  vacancies?: Maybe<Scalars["Int"]["output"]>;
  /** List of validation errors  */
  validationErrors?: Maybe<Array<Maybe<EditorValidationError>>>;
};

export type SessionAssignment = {
  __typename?: "SessionAssignment";
  blockRange?: Maybe<BlockRange>;
  blocks?: Maybe<Array<Maybe<Block>>>;
  classroom?: Maybe<Classroom>;
  classrooms?: Maybe<Array<Maybe<Classroom>>>;
  day?: Maybe<Day>;
  days?: Maybe<Array<Maybe<Day>>>;
  instructor?: Maybe<Instructor>;
  instructors?: Maybe<Array<Maybe<Instructor>>>;
  intervalRange?: Maybe<IntervalRange>;
  intervals?: Maybe<Array<Maybe<Interval>>>;
};

export type SessionAssignmentBookingInput = {
  assignedDates: Array<InputMaybe<DateTimeRangeInput>>;
  classroomId: Scalars["ID"]["input"];
};

export type SessionCrudChangesetInput = {
  creates?: InputMaybe<Array<InputMaybe<EditorChangesetInput>>>;
  /** Sections (with cascade) and/or individual sessions to soft-delete. Replaces the legacy flat list of session IDs — pass an object with { sections: [], sessions: [] } instead. */
  deletes?: InputMaybe<SessionCrudDeletesInput>;
  updates?: InputMaybe<Array<InputMaybe<EditorChangesetInput>>>;
};

/** Structured deletes: sections (with cascade to their sessions) and/or individual sessions in a single operation */
export type SessionCrudDeletesInput = {
  /** Section IDs to soft-delete with cascade to all their sessions */
  sections?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /** Session IDs to soft-delete individually */
  sessions?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SessionCrudInput = {
  /** the changes we want to perform in this operation */
  changesets?: InputMaybe<SessionCrudChangesetInput>;
  /** a rehearsal of a performance or procedure before the real one */
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Controls the create flow. "assignation" (default) assigns sessions to existing sections via sectionId. "programming" enables microprogramming: sessions without a sectionId will create a new section from componentId + courseId. */
  editionMode?: InputMaybe<EditionMode>;
  linkId?: InputMaybe<Scalars["ID"]["input"]>;
  /** ID of the ProgrammingStructure to associate with the link after a successful programming operation. Only applied when editionMode is "programming". */
  programmingStructureId?: InputMaybe<Scalars["ID"]["input"]>;
  /** kip any validations that could cancel the operation */
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** IDs of the instructors the user explicitly removed from the link in this operation. Used to register their group drop date when the instructor tag is enabled. */
  unassignedInstructorIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type SessionCrudPayload = {
  __typename?: "SessionCrudPayload";
  creates?: Maybe<Array<Maybe<SessionPayload>>>;
  deletes?: Maybe<Array<Maybe<SessionPayload>>>;
  updates?: Maybe<Array<Maybe<SessionPayload>>>;
};

export type SessionCrudResult = {
  __typename?: "SessionCrudResult";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  payload?: Maybe<SessionCrudPayload>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  /** If user can skip some of the validations because has not assigned an ability */
  userCanSkipValidations?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SessionPage = {
  __typename?: "SessionPage";
  items: Array<Session>;
  pageInfo?: Maybe<PageInfo>;
};

export type SessionPayload = {
  __typename?: "SessionPayload";
  customValidations?: Maybe<Array<Maybe<CustomValidation>>>;
  intervalValidationErrors?: Maybe<Array<Maybe<IntervalValidationErrors>>>;
  sessionId?: Maybe<Scalars["ID"]["output"]>;
  sessionUuid?: Maybe<Scalars["String"]["output"]>;
  validationErrors?: Maybe<Array<Maybe<EditorValidationError>>>;
};

export type SessionRecommendation = {
  __typename?: "SessionRecommendation";
  html?: Maybe<Scalars["String"]["output"]>;
  recommendation?: Maybe<Array<Maybe<Recommendation>>>;
};

export type SessionValidationErrorUnion = InvalidClassroomCapacity;

export type SessionsByHolidaysPayload = {
  __typename?: "SessionsByHolidaysPayload";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  link?: Maybe<Array<Maybe<Link>>>;
  validationErrors?: Maybe<Array<Maybe<EditorValidationError>>>;
};

export type SessionsMultiEditInput = {
  /** the changes we want to perform in this operation */
  changesets?: InputMaybe<Array<InputMaybe<EditorChangesetInput>>>;
  /** a rehearsal of a performance or procedure before the real one. (for @nicolás) */
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** kip any validations that could cancel the operation */
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SessionsMultiEditPayload = {
  __typename?: "SessionsMultiEditPayload";
  commited?: Maybe<Scalars["Boolean"]["output"]>;
  sessionsPayload?: Maybe<Array<Maybe<SessionPayload>>>;
  skippedValidations?: Maybe<Scalars["Boolean"]["output"]>;
  /** If user can skip some of the validations because has not assigned an ability */
  userCanSkipValidations?: Maybe<Scalars["Boolean"]["output"]>;
};

export type Setting = {
  __typename?: "Setting";
  config?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  value?: Maybe<Scalars["String"]["output"]>;
  valueType: Scalars["String"]["output"];
};

export type SettingFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<SettingFilterFieldsInput>>>;
  config?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SettingFilterFieldsInput>>>;
  value?: InputMaybe<StringFilterInput>;
};

export type SettingFilterInput = {
  fields?: InputMaybe<SettingFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type SettingPage = {
  __typename?: "SettingPage";
  items: Array<Setting>;
  pageInfo?: Maybe<PageInfo>;
};

export type SharedPackComponent = {
  component?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
};

export type SharedPackComponents = {
  __typename?: "SharedPackComponents";
  code?: Maybe<Scalars["String"]["output"]>;
  component?: Maybe<Scalars["String"]["output"]>;
  existingLabels?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  groupCodeSeparator?: Maybe<Scalars["String"]["output"]>;
  numericGroupCode?: Maybe<Scalars["Boolean"]["output"]>;
  order?: Maybe<Scalars["Int"]["output"]>;
  prefix?: Maybe<Scalars["String"]["output"]>;
};

export type SharedPackComponentsInput = {
  bundleId: Scalars["ID"]["input"];
  courseId: Scalars["ID"]["input"];
  linkId: Scalars["ID"]["input"];
};

export type Shift = {
  __typename?: "Shift";
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ShiftFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<ShiftFilterFieldsInput>>>;
  code?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ShiftFilterFieldsInput>>>;
};

export type ShiftFilterInput = {
  fields?: InputMaybe<ShiftFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ShiftPage = {
  __typename?: "ShiftPage";
  items: Array<Shift>;
  pageInfo?: Maybe<PageInfo>;
};

export type StageInstancesInput = {
  instances: Array<MicroprogrammingInstanceInput>;
  stageCode: Scalars["String"]["input"];
  stageName?: InputMaybe<Scalars["String"]["input"]>;
};

export type StringFilterInput = {
  contains?: InputMaybe<Scalars["String"]["input"]>;
  endsWith?: InputMaybe<Scalars["String"]["input"]>;
  eq?: InputMaybe<Scalars["String"]["input"]>;
  gt?: InputMaybe<Scalars["String"]["input"]>;
  gte?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  lt?: InputMaybe<Scalars["String"]["input"]>;
  lte?: InputMaybe<Scalars["String"]["input"]>;
  ne?: InputMaybe<Scalars["String"]["input"]>;
  nil?: InputMaybe<Scalars["Boolean"]["input"]>;
  nin?: InputMaybe<Array<Scalars["String"]["input"]>>;
  notContains?: InputMaybe<Scalars["String"]["input"]>;
  notEndsWith?: InputMaybe<Scalars["String"]["input"]>;
  notStartsWith?: InputMaybe<Scalars["String"]["input"]>;
  regex?: InputMaybe<Scalars["String"]["input"]>;
  startsWith?: InputMaybe<Scalars["String"]["input"]>;
};

export type Stripe = {
  __typename?: "Stripe";
  blocks?: Maybe<Array<Maybe<Block>>>;
  code?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type StripePriority = {
  __typename?: "StripePriority";
  id: Scalars["ID"]["output"];
  name: Scalars["Int"]["output"];
  stripe: Stripe;
};

export type Student = {
  __typename?: "Student";
  code?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
  meta?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

export type StudentClash = {
  __typename?: "StudentClash";
  count?: Maybe<Scalars["Int"]["output"]>;
  students?: Maybe<Array<Maybe<Student>>>;
};

export type Subject = {
  __typename?: "Subject";
  academicUnits?: Maybe<Array<Maybe<AcademicUnit>>>;
  code?: Maybe<Scalars["String"]["output"]>;
  credits?: Maybe<Scalars["Int"]["output"]>;
  enrollmentRestrictions?: Maybe<Array<Maybe<EnrollmentRestriction>>>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type SubjectFilterInput = {
  fields?: InputMaybe<SubjectSearchFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type SubjectPage = {
  __typename?: "SubjectPage";
  items: Array<Subject>;
  pageInfo?: Maybe<PageInfo>;
};

export type SubjectSearchFieldsInput = {
  and?: InputMaybe<SubjectSearchFieldsInput>;
  campus?: InputMaybe<IntFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  credits?: InputMaybe<IntFilterInput>;
  department?: InputMaybe<IntFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<SubjectSearchFieldsInput>;
  school?: InputMaybe<IntFilterInput>;
  searchTerm?: InputMaybe<Scalars["String"]["input"]>;
};

export type Tag = {
  __typename?: "Tag";
  code?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  modelExtension?: Maybe<ModelExtension>;
  name?: Maybe<Scalars["String"]["output"]>;
  valueType?: Maybe<Scalars["String"]["output"]>;
};

export type TagFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<TagFilterFieldsInput>>>;
  code?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<TagFilterFieldsInput>>>;
};

export type TagFilterInput = {
  fields?: InputMaybe<TagFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type TagPage = {
  __typename?: "TagPage";
  items: Array<Tag>;
  pageInfo?: Maybe<PageInfo>;
};

export type Teaching = {
  __typename?: "Teaching";
  courseComponent?: Maybe<CourseComponent>;
  id: Scalars["ID"]["output"];
  instructor: Instructor;
  maxHours?: Maybe<Scalars["Int"]["output"]>;
  priority: Scalars["Int"]["output"];
};

export type Term = {
  __typename?: "Term";
  active?: Maybe<Scalars["Boolean"]["output"]>;
  code?: Maybe<Scalars["String"]["output"]>;
  cycle?: Maybe<Scalars["Int"]["output"]>;
  end_date?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  intervals?: Maybe<Array<Maybe<Interval>>>;
  legacy?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  regular?: Maybe<Scalars["Boolean"]["output"]>;
  start_date?: Maybe<Scalars["String"]["output"]>;
  year?: Maybe<Scalars["Int"]["output"]>;
};

export type TermFilterInput = {
  fields?: InputMaybe<TermSearchFieldsInput>;
  filterbySetting?: InputMaybe<Scalars["Boolean"]["input"]>;
  pagination?: InputMaybe<PaginationInput>;
};

export type TermPage = {
  __typename?: "TermPage";
  items: Array<Term>;
  pageInfo?: Maybe<PageInfo>;
};

export type TermPart = {
  __typename?: "TermPart";
  category: TermPartCategory;
  code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type TermPartCategory = {
  __typename?: "TermPartCategory";
  code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type TermPartFilterFieldsInput = {
  and?: InputMaybe<Array<TermPartFilterFieldsInput>>;
  code?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<TermPartFilterFieldsInput>>;
  weeksByLinkId?: InputMaybe<IntFilterInput>;
};

export type TermPartFilterInput = {
  fields?: InputMaybe<TermPartFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type TermPartPage = {
  __typename?: "TermPartPage";
  items: Array<TermPart>;
  pageInfo?: Maybe<PageInfo>;
};

export type TermSearchFieldsInput = {
  and?: InputMaybe<TermSearchFieldsInput>;
  or?: InputMaybe<TermSearchFieldsInput>;
  searchTerm?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ThemeEnum {
  /** Avocado Dark mode */
  Dark = "dark",
  /** Avocado Light mode (default) */
  Light = "light",
}

export type TimeRange = {
  __typename?: "TimeRange";
  end?: Maybe<Scalars["String"]["output"]>;
  start?: Maybe<Scalars["String"]["output"]>;
};

export type TimeRangeInputType = {
  end?: InputMaybe<Scalars["String"]["input"]>;
  start?: InputMaybe<Scalars["String"]["input"]>;
};

export type TravelClash = {
  __typename?: "TravelClash";
  blocksBetween?: Maybe<Scalars["Int"]["output"]>;
  blocksRequired?: Maybe<Scalars["Int"]["output"]>;
  from?: Maybe<Session>;
  fromBuilding?: Maybe<Building>;
  to?: Maybe<Session>;
  toBuilding?: Maybe<Building>;
};

export type UpdateAssignationTypeChangesetInput = {
  assignationTypeId?: InputMaybe<Scalars["ID"]["input"]>;
  instructorLinkId: Scalars["ID"]["input"];
  linkId: Scalars["ID"]["input"];
};

export type UpdateAssignationTypeInput = {
  changesets: Array<UpdateAssignationTypeChangesetInput>;
};

export type UpdateClassroomBookingInput = {
  capacity?: InputMaybe<Scalars["Int"]["input"]>;
  classroomBookingId: Scalars["ID"]["input"];
  classroomBookingTypeId?: InputMaybe<Scalars["ID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  isRecurrent?: InputMaybe<Scalars["Boolean"]["input"]>;
  programId?: InputMaybe<Scalars["ID"]["input"]>;
  responsibleId: Scalars["ID"]["input"];
  sessionAssignmentBookings: Array<InputMaybe<SessionAssignmentBookingInput>>;
  title: Scalars["String"]["input"];
};

export type UpdateInstructorLinkTagsChangesetInput = {
  instructorLinkId: Scalars["ID"]["input"];
  tags?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type UpdateInstructorLinkTagsInput = {
  changesets: Array<UpdateInstructorLinkTagsChangesetInput>;
};

export type UpdateInstructorLinkTagsPayload = {
  __typename?: "UpdateInstructorLinkTagsPayload";
  commited: Scalars["Boolean"]["output"];
  validations?: Maybe<Array<Maybe<InstructorLinkValidationErrorUnion>>>;
};

export type UpdateLinkInput = {
  dryRun?: InputMaybe<Scalars["Boolean"]["input"]>;
  label: Scalars["String"]["input"];
  linkId: Scalars["ID"]["input"];
  skipValidations?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateProgrammingStructureInput = {
  campusCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  code?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  isPublished?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  programmingStructureParts?: InputMaybe<Array<InputMaybe<UpdateProgrammingStructurePartInput>>>;
  subjectCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UpdateProgrammingStructurePartInput = {
  blockDuration?: InputMaybe<Scalars["Int"]["input"]>;
  code?: InputMaybe<Scalars["String"]["input"]>;
  dependenciesCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  programmingStructureStageId?: InputMaybe<Scalars["ID"]["input"]>;
  references?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type User = {
  __typename?: "User";
  abilities?: Maybe<UserAbilities>;
  accessCodes?: Maybe<Array<Maybe<AccessCode>>>;
  context?: Maybe<CubeContext>;
  darwinToken?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  identityToken?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  permissions?: Maybe<UserPermissions>;
  preferences?: Maybe<PreferencesType>;
  username: Scalars["String"]["output"];
};

export type UserAbilities = {
  __typename?: "UserAbilities";
  can_access_group_manager?: Maybe<Scalars["Boolean"]["output"]>;
  can_assign_blocks?: Maybe<Scalars["Boolean"]["output"]>;
  can_assign_classrooms?: Maybe<Scalars["Boolean"]["output"]>;
  can_assign_instructors?: Maybe<Scalars["Boolean"]["output"]>;
  can_assign_instructors_from_other_courses?: Maybe<Scalars["Boolean"]["output"]>;
  can_assign_intervals?: Maybe<Scalars["Boolean"]["output"]>;
  can_create_groups_in_bundle_view?: Maybe<Scalars["Boolean"]["output"]>;
  can_create_sub_groups_in_group_manager?: Maybe<Scalars["Boolean"]["output"]>;
  can_delete_groups_in_bundle_view?: Maybe<Scalars["Boolean"]["output"]>;
  can_delete_packages?: Maybe<Scalars["Boolean"]["output"]>;
  can_delete_sections?: Maybe<Scalars["Boolean"]["output"]>;
  can_delete_sessions_in_holidays?: Maybe<Scalars["Boolean"]["output"]>;
  can_edit_assignment?: Maybe<Scalars["Boolean"]["output"]>;
  can_edit_bookings?: Maybe<Scalars["Boolean"]["output"]>;
  can_edit_groups_in_bundle_view?: Maybe<Scalars["Boolean"]["output"]>;
  can_edit_groups_in_group_manager?: Maybe<Scalars["Boolean"]["output"]>;
  can_edit_links_and_sections?: Maybe<Scalars["Boolean"]["output"]>;
  can_edit_or_delete_sessions?: Maybe<Scalars["Boolean"]["output"]>;
  can_edit_packages?: Maybe<Scalars["Boolean"]["output"]>;
  can_edit_past_sessions?: Maybe<Scalars["Boolean"]["output"]>;
  can_edit_programming?: Maybe<Scalars["Boolean"]["output"]>;
  can_edit_programming_for_started_links?: Maybe<Scalars["Boolean"]["output"]>;
  can_edit_retaker_capacities?: Maybe<Scalars["Boolean"]["output"]>;
  can_migrate_groups_in_bundle_view?: Maybe<Scalars["Boolean"]["output"]>;
  can_skip_program_selection?: Maybe<Scalars["Boolean"]["output"]>;
  can_skip_programming_stage_completeness_validation?: Maybe<Scalars["Boolean"]["output"]>;
  can_skip_programming_stage_dependencies_validation?: Maybe<Scalars["Boolean"]["output"]>;
  can_skip_scheduled_blocks_validation?: Maybe<Scalars["Boolean"]["output"]>;
  can_skip_total_blocks?: Maybe<Scalars["Boolean"]["output"]>;
  can_skip_unscheduled_programming_stage_validation?: Maybe<Scalars["Boolean"]["output"]>;
  can_unassign_intervals?: Maybe<Scalars["Boolean"]["output"]>;
  instructor_scheduled_hours?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UserConfiguration = {
  __typename?: "UserConfiguration";
  accesible?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  path?: Maybe<Scalars["String"]["output"]>;
  permissions?: Maybe<UserPermissionsAction>;
};

export type UserConfigurationAccesibleArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UserConfigurationPermissionsArgs = {
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UserFilterFieldsInput = {
  and?: InputMaybe<Array<InputMaybe<UserFilterFieldsInput>>>;
  id?: InputMaybe<IntFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<UserFilterFieldsInput>>>;
  username?: InputMaybe<StringFilterInput>;
};

export type UserFilterInput = {
  fields?: InputMaybe<UserFilterFieldsInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type UserPage = {
  __typename?: "UserPage";
  items: Array<User>;
  pageInfo?: Maybe<PageInfo>;
};

export type UserPermissions = {
  __typename?: "UserPermissions";
  create?: Maybe<Scalars["Boolean"]["output"]>;
  delete?: Maybe<Scalars["Boolean"]["output"]>;
  read?: Maybe<Scalars["Boolean"]["output"]>;
  update?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UserPermissionsAction = {
  __typename?: "UserPermissionsAction";
  create?: Maybe<Scalars["Boolean"]["output"]>;
  delete?: Maybe<Scalars["Boolean"]["output"]>;
  import?: Maybe<Scalars["Boolean"]["output"]>;
  read?: Maybe<Scalars["Boolean"]["output"]>;
  update?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum ValidationErrorReason {
  AccessDeniedToGroupManager = "ACCESS_DENIED_TO_GROUP_MANAGER",
  AssignationTypeNotFound = "ASSIGNATION_TYPE_NOT_FOUND",
  CanEditPackages = "CAN_EDIT_PACKAGES",
  ClashesBetweenPackages = "CLASHES_BETWEEN_PACKAGES",
  ClassroomCapacityExceeded = "CLASSROOM_CAPACITY_EXCEEDED",
  CouldNotCreateGroup = "COULD_NOT_CREATE_GROUP",
  DatabaseError = "DATABASE_ERROR",
  EnrollmentsNotCovered = "ENROLLMENTS_NOT_COVERED",
  ExeedsMax = "EXEEDS_MAX",
  GroupCapacityChangeError = "GROUP_CAPACITY_CHANGE_ERROR",
  GroupCodeAlreadyTaken = "GROUP_CODE_ALREADY_TAKEN",
  GroupHasEnrollments = "GROUP_HAS_ENROLLMENTS",
  GroupIsAlreadyReferent = "GROUP_IS_ALREADY_REFERENT",
  GroupLinkNotFound = "GROUP_LINK_NOT_FOUND",
  GroupNotFound = "GROUP_NOT_FOUND",
  GroupNotYetMigrated = "GROUP_NOT_YET_MIGRATED",
  GroupVacanciesExternalValidation = "GROUP_VACANCIES_EXTERNAL_VALIDATION",
  GroupVisibilityChangeError = "GROUP_VISIBILITY_CHANGE_ERROR",
  InstructorLinkNotFound = "INSTRUCTOR_LINK_NOT_FOUND",
  IntervalNotFound = "INTERVAL_NOT_FOUND",
  InvalidAccessCode = "INVALID_ACCESS_CODE",
  InvalidClassroom = "INVALID_CLASSROOM",
  InvalidClassroomBookingDelete = "INVALID_CLASSROOM_BOOKING_DELETE",
  InvalidComponent = "INVALID_COMPONENT",
  InvalidCourse = "INVALID_COURSE",
  InvalidCourseComponent = "INVALID_COURSE_COMPONENT",
  InvalidGroup = "INVALID_GROUP",
  InvalidLink = "INVALID_LINK",
  InvalidLinkCourse = "INVALID_LINK_COURSE",
  InvalidLinkPackage = "INVALID_LINK_PACKAGE",
  InvalidPaymentPercentage = "INVALID_PAYMENT_PERCENTAGE",
  InvalidSection = "INVALID_SECTION",
  InvalidTeachingHoursPercentage = "INVALID_TEACHING_HOURS_PERCENTAGE",
  IsNotTheOwnerOfTheGroup = "IS_NOT_THE_OWNER_OF_THE_GROUP",
  LinkCodeAlreadyInUse = "LINK_CODE_ALREADY_IN_USE",
  LinkHasLabelAssigned = "LINK_HAS_LABEL_ASSIGNED",
  LinkIsNotSharedType = "LINK_IS_NOT_SHARED_TYPE",
  LinkLabelAlreadyInUse = "LINK_LABEL_ALREADY_IN_USE",
  LinkNotFound = "LINK_NOT_FOUND",
  LowerThanMin = "LOWER_THAN_MIN",
  MaxAssignationTypeExceeded = "MAX_ASSIGNATION_TYPE_EXCEEDED",
  MissingSectionCreateFields = "MISSING_SECTION_CREATE_FIELDS",
  MissingTermId = "MISSING_TERM_ID",
  MoreThanOnePrimaryInstructor = "MORE_THAN_ONE_PRIMARY_INSTRUCTOR",
  MustSetPrimaryInstructor = "MUST_SET_PRIMARY_INSTRUCTOR",
  NumericGroupCodeValidation = "NUMERIC_GROUP_CODE_VALIDATION",
  PackageNotPublished = "PACKAGE_NOT_PUBLISHED",
  PackagePublishingDisabled = "PACKAGE_PUBLISHING_DISABLED",
  PendingChangeRequest = "PENDING_CHANGE_REQUEST",
  RepeatedComponentForLink = "REPEATED_COMPONENT_FOR_LINK",
  RetakerCapacityExceedsTotal = "RETAKER_CAPACITY_EXCEEDS_TOTAL",
  SectionCapacityExceedsCourseComponentMaxSize = "SECTION_CAPACITY_EXCEEDS_COURSE_COMPONENT_MAX_SIZE",
  SessionNotFound = "SESSION_NOT_FOUND",
  SharedLinkSections = "SHARED_LINK_SECTIONS",
  SharedPackComponentNotFound = "SHARED_PACK_COMPONENT_NOT_FOUND",
  SubjectNotFound = "SUBJECT_NOT_FOUND",
  SubjectTermMismatch = "SUBJECT_TERM_MISMATCH",
  UserCannotDeletePackages = "USER_CANNOT_DELETE_PACKAGES",
  UserCannotDeleteSection = "USER_CANNOT_DELETE_SECTION",
  UserCannotDeleteSectionWithSession = "USER_CANNOT_DELETE_SECTION_WITH_SESSION",
  UserCannotEditLink = "USER_CANNOT_EDIT_LINK",
  WaitingListNotCovered = "WAITING_LIST_NOT_COVERED",
}

export type Workspace = {
  __typename?: "Workspace";
  code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  institution?: Maybe<Institution>;
  name: Scalars["String"]["output"];
};
